import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useCallback, useEffect, useRef, useState } from "react";
import { MultiSelect } from "primereact/multiselect";
import Disclaimer from "../disclaimer/Disclaimer";
import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primeflex/primeflex.scss";
import "./style.css";
import Parameters from "../parameters/Parameters";
import { FaBookBookmark } from "react-icons/fa6";
import debounce from "lodash/debounce";
import {ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GET_ALL_TRADES, GET_M2M_ARRAY, GET_ONLY_TARGET_STOPLOSS, GET_TOTAL_TRADES, GET_TRADE_COUNT } from "../../graphql/liveQuery/queries";
import { useLazyQuery } from "@apollo/client";
import csvDownload from "json-to-csv-export";
import moment from "moment-timezone";
import Cookies from 'js-cookie'
import { useDispatch, useSelector } from "react-redux";
import Calender from "../calender/Calender";
import { backdatedParamsSet, backdatedParamsSet1 } from "../../services/util/backdatedParams";
import { backDatedGetModalReturns, getModalReturns } from "../../services/util/rightsidebar";
import axios from "axios";

import { backdatedInitSuccessRatio, initSuccessRatio, updateObj } from "../../services/util/initSuccessRatio";
import ChartComponent from "../Charts/CandlestickChart/chartCompontent";
import { setRightSidebarReturn, setSuccessRatioData } from "../../store/rightSidebarReturnSlice";
import { returnCalculator } from "../../services/util/returnCalculator";
import { setReturnCalculator, setSelectedDateStore } from "../../store/todayReturnCalculator";

import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowAltCircleRight, faCircle } from "@fortawesome/free-solid-svg-icons";
import { getColumnOrder, getReleaseNote, getWordCloudImage, saveColumnOrder } from "../../api/otherEndPoints/necessoryEndPoints";
import { getUserMail } from "../../services/util/getUserMail";
import { APP_VERSION, backdatedCSVTargetSlNormalizer, csvTargetSlNormalize, toTitleCase } from "../../services/util/normalize";
import { IoBarChartSharp } from "react-icons/io5";
import { liveOverAllAdviceStatus } from "../../api/axios";
import { ThreeDots } from "react-loader-spinner";
import { StockChart } from "../Charts/StockChart/stockChart";
import { calculate_m2m_graph } from "../../services/util/newsSentiment";
import M2mGraphChart from "../Charts/m2mGrapHChart/M2mGraphChart";
import ProductNote from "./productNote";
import { HiOutlineDownload } from 'react-icons/hi';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { getTradeReason } from '../../api/otherEndPoints/necessoryEndPoints';
import { getStartEndDateSF } from "../../api/historicalEndPoints/stockFutIntraday";
import { getPLPercentageResponse } from "../../services/util/historicalComponentsResponses";
import { useParams } from "react-router-dom";
import pushNotification, { ActiveTab, AdviceType, LivePageHistocalexportCSV, TradesCount, TslObject, accessChecking, csvColumnMap, isPrivilegedAndCurrebtDate, modelCodeMaking } from "../../services/util/util";
import { backdatedColumns, backdatedEquityColumns, backdatedEquityN50Columns, backdatedOptLongColumns, columns, equityN50_columns, equity_columns, optLong_columns } from "../../services/util/helper";
import { useSocketEvent } from "../../store/hooks/useSocketEvent";
import ReturnContainer from "../returnContainer/ReturnContainer";
import { Switch, Tooltip } from "antd";
import { throttle } from "lodash";
import PreviewTable from "./PreviewTable";






export default function LiveDataTable() {
  let modalshow: any = localStorage.getItem('release_show_count')
  const dispatch = useDispatch();
  const type:any = useParams()
  const rows:number = 50; //per page trade limit
  const [activeTab, setActiveTab] = useState<ActiveTab>("Live");
  const activeRef = useRef(null);
  const liveBtnRef = useRef(null);
  const executedBtnRef = useRef(null);
  const [activeStyle, setActiveStyle] = useState({});
  const liveDataRef = useRef([]);

  const [tradeCount, setTradeCount] = useState<TradesCount>({
    FNO: 0,
    LFT: 0,
    EQ: 0,
    EqN50plus: 0,
    OPT_LONG: 0,
    EqBANK : 0,
    EqIT: 0
  });
 

  const [liveData, setLiveData] = useState<any[]>([]);
  const [liveBtn, setLiveBtn] = useState<boolean>(false);
  const [tradeSortOrder, setTradeSortOrder] = useState<any>(0);
  const [desc_ts, setDesc_Ts] = useState<any>([]);
  const [multiSelect, setMultiSelect] = useState<any>(false);
  const [selectedTradeId, setSelectedTradeId] = useState<string>(' ');
  const [selectedTrade, setSelectedTrade] = useState<any>(null)
  const [adviceType, setAdviceType] = useState<AdviceType>("FNO");
  const [sortFieldState, setSortFieldState] = useState('s_symbol');
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const [allTradesData, setAllTradesData] = useState<any>([]);
  const [filteredFNOData, setFilteredFNOData] = useState<any>([]);
  const [filteredLFTData, setFilteredLFTData] = useState<any>([]);
  const [filteredEQData, setFilteredEQData] = useState<any>([]);
  const [filteredEQBankData, setFilteredEQBankData] = useState<any>([]);
  const [filteredOptLongData, setFilteredOptLongData] = useState<any>([]);
  const [calenderisvisisble, setCalenderIsVisisble] = useState<any>(false)
  const [liveOverAllData, setLiveOverAllData] = useState<any>([]);
  const [backdatedDesc_ts, setBackdatedDesc_Ts] = useState<any>([]);
  const [BackdatedFilteredFNOData, setBackdatedFilteredFNOData] = useState<any>([]);
  const [BackdatedFilteredLFTData, setBackdatedFilteredLFTData] = useState<any>([]);
  const [BackdatedFilteredEQData, setBackdatedFilteredEQData] = useState<any>([]);
  const [BackdatedFilteredOptLongData, setBackdatedFilteredOptLongData] = useState<any>([]);
  const [wordCloudImgUpdateTime, setWordCloudImgUpdateTime] = useState<any>(null)
  const [modalReturns, setModalReturns] = useState<any>([]);
  const [selectedDate, setSelectedDate] = useState<any>(moment(new Date()).format("YYYY-MM-DD")) //new added
  const [successRatio, setSuccessRatio] = useState<any>({});
  const [releaseShowCount, setReleaseShowCount] = useState<any>(0)
  const [releaseNoteShow, setReleaseNoteShow] = useState<any>(true);
  const [releaseDetails, setReleaseDetails] = useState<any>([])
  const [releaseNoteChkBox, setReleaseNoteChkBox] = useState<any>(false)
  const [viewNIFTYCharts, setViewNIFTYCharts] = useState<boolean>(false)
  const [viewSTOCKCharts, setViewSTOCKCharts] = useState<boolean>(false)
  const [wordCloudImage, setWordCloudImage] = useState<any>(null)
  const [wordCloudDataSocket, setWordCloudDataSocket] = useState<any>({})
  const [loader, setLoader] = useState<any>(false)
  const [tradeReason, setTradeReason] = useState<any>({});
  const [startandEndDate,setStartAndEndDate] = useState<any>({});
  const [stockStrength, setStockStrength] = useState<string>('');
  const [orderedCol, setOrderedCol] = useState<[]>([]);
  const [orderedColEq, setOrderedColEq] = useState<[]>([]);
  // const [orderedColEqN50, setOrderedColEqN50] = useState<[]>([]);
  //Changes added for graph
  const [m2mGraphArray, setM2mGraphArray] = useState<any>([])
  const [ currDateSelected, setCurrDateSelected ] = useState<any>(true)
  const [ calenderValue, setCalenderValue ] = useState<any>(false)
  const [first,setFirst] = useState<number>(0);
  //New added for back dated column

  const [visibleColumns, setVisibleColumns] = useState<any>(columns);
  const [backdatedVisibleColumns, setBackdatedVisibleColumns] = useState<any>(backdatedColumns);
  const [eqvisibleColumns, setEqVisibleColumns] = useState<any>(equity_columns);
  const [eqN50visibleColumns, setEqN50VisibleColumns] = useState<any>(equityN50_columns);
  const [optLongvisibleColumns, setOptLongVisibleColumns] = useState<any>(optLong_columns);
  const [backdatedOptLongvisibleColumns, setbackdatedOptLongVisibleColumns] = useState<any>(backdatedOptLongColumns);
  const [backdatedeqVisibleColumnsState, setBackdatedeqVisibleColumnsState] = useState<any>(backdatedEquityColumns);
  const [backdatedeqN50VisibleColumnsState, setBackdatedeqN50VisibleColumnsState] = useState<any>(backdatedEquityN50Columns);

  //=-------------------- NEW ----------------------------//
  const [filteredEqN50Data, setFilteredEqN50Data] = useState<any>([]);
  const [BackdatedFilteredEqN50Data, setBackdatedFilteredEqN50Data] = useState<any>([]);

  const [selectedPreviewTableData, setSelectedPreviewTableData] = useState<any[]>([]);

//   const exportCSV = (selectionOnly:boolean) => {
//     const exportData = selectionOnly ? [] : liveData; // your state

//     if (!exportData.length) return;

//     // Add extra column(s)
//     const enrichedData = exportData.map((row: any) => {
//       const { j_m2m, ...rest } = row; // Remove 'j_m2m'
//       return {
//         ...rest,
//         Dividend: JSON.stringify(row?.j_dividend),
//         j_target_stoploss: JSON.stringify(row?.j_target_stoploss),
//       };
//     });
  
//     // Get column headers dynamically or manually
//     const headers = Object.keys(enrichedData[0]);
    
//   // Build header row using the map
//   const renamedHeaders = headers.map((key) => csvColumnMap[key] || key);

//   const csvContent = [
//     renamedHeaders.join(','), // Mapped header row
//     ...enrichedData.map(row =>
//       headers.map(field => `"${row[field] ?? ''}"`).join(',')
//     )
//   ].join('\n');
  
//     // Trigger file download
//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const link = document.createElement('a');
//     const filename = `Trades_${new Date().toISOString().slice(0, 10)}.csv`;
  
//     link.setAttribute('href', URL.createObjectURL(blob));
//     link.setAttribute('download', filename);
//     link.click();


// };


const exportCSV = (selectionOnly: boolean) => {

  const exportData = selectionOnly ? [] : liveData;
  if (!exportData.length) return;

  const columns = Object.keys(csvColumnMap); // use defined field order

  const enrichedData = exportData.map((row: any) => {
    // Flatten or stringify necessary fields
    return {
      ...row,
      j_dividend: JSON.stringify(row.j_dividend ?? []),
      j_target_stoploss: JSON.stringify(
        Array.isArray(row?.j_target_stoploss)
          ? row.j_target_stoploss.map((item:any) => ({
              time: item?.time || '',
              Target: item?.Target ?? '',
              Stoploss: item?.Stoploss ?? ''
            }))
          : []
      )
    };
  });

  const renamedHeaders = columns.map(key => csvColumnMap[key] || key);

  const csvRows = enrichedData.map((row:any) =>
    columns.map((field) => {
      const value = row[field];
      if (typeof value === 'object' && value !== null) {
        return `"${JSON.stringify(value)}"`; // safe stringifying
      }
      return `"${value ?? ''}"`;
    }).join(',')
  );

  // console.log("Enrich ",enrichedData);
  //  setSelectedPreviewTableData(enrichedData))

  const csvContent = [renamedHeaders.join(','), ...csvRows].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const filename = `Trades_${new Date().toISOString().slice(0, 10)}.csv`;

  link.setAttribute('href', URL.createObjectURL(blob));
  link.setAttribute('download', filename);
  link.click();
};

const memorizedExportCSV = useCallback(exportCSV,[isModalOpen])
const onDownload = useCallback(() => memorizedExportCSV(false), [memorizedExportCSV]);


  const theme: any = useSelector((state: any) => {
    return state.theme.isTheme;
  })
  const selectedModels: any = useSelector((state: any) => {
    return state?.selectedModelsArr?.selectedModels;
  })

  // const handleNewRow = (row:any) => {
  //   if (row?.trade_category !== adviceType) return;
  
  //   setLiveData((prev) => {
  //     const alreadyExists = prev.some(item => item?.unique_id === row?.unique_id);
  //     if (!alreadyExists) {
  //       // Find the selected trade from the incoming data
  //       const updated = [row, ...prev];
  //       const trade = updated.find(item => item?.unique_id === selectedTradeId);
  //       setSelectedTrade(trade);
  
  //       return updated;
  //     }
  //     return prev;
  //   });
  // };

  const handleNewRow = (row:any) => {
    if (row?.trade_category !== adviceType) return;

    const current_date: any = new Date();

    let cookiesCodesArr: any = Cookies.get('codesArray') || []

    const isPassed:boolean = isPrivilegedAndCurrebtDate(cookiesCodesArr, row, selectedDate, current_date);
 
    if (isPassed) {

      setLiveData((prev) => {
        const alreadyExists = prev.some(item => item?.unique_id === row?.unique_id);
        if (!alreadyExists) {
          // Find the selected trade from the incoming data
          const updated = [row, ...prev];
          const trade = updated.find(item => item?.unique_id === selectedTradeId);
          setSelectedTrade(trade);
   
          return updated;
        }
        return prev;
      });
    }
  }; 
  

  // const handleSorting=(e:any)=>{
  //   console.log("EVENT ",e);
  //   let temp_sorted_arr:any[];
  //   if(e?.sortOrder === 1){

  //     temp_sorted_arr = liveData?.sort((a:any,b:any)=>a.s_symbol.localeCompare(b.s_symbol)) //asc
  //     setTradeSortOrder(e?.sortOrder);
  //   }
  //   else{
  //     temp_sorted_arr = liveData?.sort((a:any,b:any)=>b.s_symbol.localeCompare(a.s_symbol)) //desc
  //     setTradeSortOrder(-1);
      
  //   }
  // }

  const totalTradeCount = (adviceTypeArgument:AdviceType)=>{

    switch(adviceTypeArgument){
      case "FNO":
        return tradeCount.FNO;
      
      case "LFT":
        return tradeCount.LFT;

      case "OPT LONG":
        return tradeCount.OPT_LONG;

      case "EQ":
        return tradeCount.EQ;

      default:
        return tradeCount.FNO;
    }
  }

  const handleSorting = (e: any) => {
    console.log("EVENT SORTING:", e);
  
    let temp_sorted_arr: any[];
    const newSortOrder = tradeSortOrder === 1 ? -1 : 1; // Toggle manually
  
    console.log("New Sort Order:", newSortOrder);

    if(e?.sortField === "s_symbol"){

      if (newSortOrder === 1) {
        temp_sorted_arr = [...liveData].sort((a, b) => a.s_symbol.localeCompare(b.s_symbol)); // Ascending
      } else {
        temp_sorted_arr = [...liveData].sort((a, b) => b.s_symbol.localeCompare(a.s_symbol)); // Descending
      }
    
      console.log("Sorted Data:", temp_sorted_arr);
    
      setTradeSortOrder(newSortOrder); // Update the sort order state
      setLiveData(temp_sorted_arr); // Update data state
    }

    else if(e?.sortField === "s_code"){
      if (newSortOrder === 1) {
        temp_sorted_arr = [...liveData].sort((a, b) => a.s_code.localeCompare(b.s_code)); // Ascending
      } else {
        temp_sorted_arr = [...liveData].sort((a, b) => b.s_code.localeCompare(a.s_code)); // Descending
      }
    
      console.log("Sorted Data:", temp_sorted_arr);
    
      setTradeSortOrder(newSortOrder); // Update the sort order state
      setLiveData(temp_sorted_arr); // Update data state
    }

    else if(e?.sortField === "n_pl"){ 
      if (newSortOrder === 1) {
        temp_sorted_arr = [...liveData].sort((a, b) => a.n_pl - b.n_pl); // Ascending
      } else {
        temp_sorted_arr = [...liveData].sort((a, b) => b.n_pl - a.n_pl); // Descending
      }
    
      console.log("Sorted Data:", temp_sorted_arr);
    
      setTradeSortOrder(newSortOrder); // Update the sort order state
      setLiveData(temp_sorted_arr); // Update data state
    }
    else if(e?.sortField === "n_return"){ //n_return
      if (newSortOrder === 1) {
        temp_sorted_arr = [...liveData].sort((a, b) => a.n_return - b.n_return); // Ascending
      } else {
        temp_sorted_arr = [...liveData].sort((a, b) => b.n_return - a.n_return); // Descending
      }
    
      console.log("Sorted Data:", temp_sorted_arr);
    
      setTradeSortOrder(newSortOrder); // Update the sort order state
      setLiveData(temp_sorted_arr); // Update data state
    }

    else if(e?.sortField === "dt_entry_time"){
      if (newSortOrder === 1) {
        // Ascending: Convert "HH:mm:ss" to timestamps and sort
        temp_sorted_arr = [...liveData].sort((a, b) => 
          new Date(`1970-01-01T${a.dt_entry_time}Z`).getTime() - 
          new Date(`1970-01-01T${b.dt_entry_time}Z`).getTime()
        );
      } else {
        // Descending
        temp_sorted_arr = [...liveData].sort((a, b) => 
          new Date(`1970-01-01T${b.dt_entry_time}Z`).getTime() - 
          new Date(`1970-01-01T${a.dt_entry_time}Z`).getTime()
        );
      } 
      console.log("Sorted Data:", temp_sorted_arr);
    
      setTradeSortOrder(newSortOrder); // Update the sort order state
      setLiveData(temp_sorted_arr); // Update data state
    }

  
  
  };
  

  const fetchWordCloudImage = async () => {  
    let response:any = await getWordCloudImage()
    if(response !== undefined && response !== null){
      setWordCloudImage(response['image'])
      setWordCloudImgUpdateTime(response['update_time'])
    }
}

const secondDataModelReturn=(newData: any)=>{


  const index: any = modalReturns?.findIndex((item: any) => Object?.keys(item)[0] === newData?.s_code);
  if (index !== -1) { // If s_code exists, update count, returnPer, and returnAfter      
    const existingData: any = modalReturns[index][newData?.s_code];
    const updatedData: any = {
      count: existingData?.count,
      returnPer: existingData?.returnPer + newData?.total_return,
      returnAfter: existingData?.returnAfter + newData?.total_return_after_cost,
    };
    
    let sidebarReturnResponse: any = [
      ...modalReturns?.slice(0, index),
      { [newData?.s_code]: updatedData },
      ...modalReturns?.slice(index + 1)
    ]

    // console.log("RETRURN SIDEBAR",sidebarReturnResponse);
    dispatch(setRightSidebarReturn(sidebarReturnResponse))
    setModalReturns((prevModalReturns: any) => {
      const updatedArray = [
        ...prevModalReturns.slice(0, index),
        { [newData?.s_code]: updatedData },
        ...prevModalReturns.slice(index + 1)
      ];
      
      return updatedArray;
    });
    // if(modalReturns[0]===undefined){
    //   alert("undefined detected")
    // }
  }
 else{
  return
 }
}

// const secondDataModelReturn = (newData: any) => {
//   console.log("VALUE COMPARISON2 main -->", modalReturns, newData);

//   const index = modalReturns?.findIndex((item: any) => Object.keys(item)[0] === newData?.s_code);

//   if (index !== -1) { // If s_code exists
//     const existingKey = Object.keys(modalReturns[index])[0]; // Get the key dynamically
//     const existingData = modalReturns[index][existingKey];

//     const updatedData = {
//       count: existingData?.count + 1,  // Increment count
//       returnPer: existingData?.returnPer + newData?.n_return,
//       returnAfter: existingData?.returnAfter + newData?.n_return_after_cost,
//     };

//     const updatedArray = [
//       ...modalReturns.slice(0, index),
//       { [existingKey]: updatedData }, // Update specific object
//       ...modalReturns.slice(index + 1)
//     ];

//     console.log("VALUE COMPARISON2 updated -->", updatedArray);

//     dispatch(setRightSidebarReturn(updatedArray)); // Update global state if needed
//     setModalReturns(updatedArray); // Update local state
//   }
//   else {

//     let sidebarReturnResponse: any = [
//       ...modalReturns,
//       { [newData?.s_code]: { count: 1, returnPer: newData?.n_return, returnAfter: newData?.n_return_after_cost } }
//     ]
    
//     console.log("VALUE COMAPARISION2 else -->",sidebarReturnResponse)

//     dispatch(setRightSidebarReturn(sidebarReturnResponse))

//     setModalReturns((prevModalReturns: any) => {
//       const updatedArray: any = [
//         ...prevModalReturns,
//         { [newData?.s_code]: { count: 1, returnPer: newData?.n_return, returnAfter: newData?.n_return_after_cost } }
//       ]
//       return updatedArray
//     });
//   }
// };


const addNewInRightSidebar = (newData: any) => {
  const index: any = modalReturns?.findIndex((item: any) => Object?.keys(item)[0] === newData?.s_code);
  // console.log("VALUE COMAPARISION1 -->",index,"next ->",  newData?.s_code)

  if (index !== -1) { // If s_code exists, update count, returnPer, and returnAfter      
    const existingData: any = modalReturns[index][newData?.s_code];
    const updatedData: any = {
      count: existingData?.count + 1,
      returnPer: existingData?.returnPer + newData?.n_return,
      returnAfter: existingData?.returnAfter + newData?.n_return_after_cost,
    };
    let sidebarReturnResponse: any = [
      ...modalReturns?.slice(0, index),
      { [newData?.s_code]: updatedData },
      ...modalReturns?.slice(index + 1)
    ]

    dispatch(setRightSidebarReturn(sidebarReturnResponse))
    setModalReturns((prevModalReturns: any) => {
      const updatedArray = [
        ...prevModalReturns.slice(0, index),
        { [newData.s_code]: updatedData },
        ...prevModalReturns.slice(index + 1)
      ];
      return updatedArray;
    });
  }
  else {

    let sidebarReturnResponse: any = [
      ...modalReturns,
      { [newData?.s_code]: { count: 1, returnPer: newData?.n_return, returnAfter: newData?.n_return_after_cost } }
    ]
    

    dispatch(setRightSidebarReturn(sidebarReturnResponse))

    setModalReturns((prevModalReturns: any) => {
      const updatedArray: any = [
        ...prevModalReturns,
        { [newData?.s_code]: { count: 1, returnPer: newData?.n_return, returnAfter: newData?.n_return_after_cost } }
      ]
      return updatedArray
    });
  }
};

const onDataChange = (data: any) => {

  let tempArr:any[] = [];
  const { row } = data;

  if(((row?.s_status).toUpperCase() !== 'OPEN')) {

      if(activeTab === 'Live'){    //live tab

        if(row?.trade_category === adviceType){
          // setTradeCount((prev:TradesCount)=>{return {...prev, LFT:prev.LFT - 1}});

          if(desc_ts[0]?.row_unique_id === row?.unique_id){
            setLiveData((prev:any)=>prev?.filter((item:any)=>item?.unique_id != row?.unique_id));

            // alert(desc_ts[0]?.row_unique_id === row?.unique_id)
            if(liveData?.length === 1){ //should be 0 now if length was 1
              
              getM2MArray({
                variables:{
                  uniqueId:"None",
                }
              })
    
              setFilteredParameters({});
              setSelectedTrade(null);
              // setDesc_Ts([]);
              // setM2mGraphArray([]);
            
            } 

            else{

              getM2MArray({
                variables:{
                  uniqueId:liveData[1]?.unique_id ?? ' ',
                }
              })
    
              setFilteredParameters(liveData[1] ?? {});
              setSelectedTrade(liveData[1]?.unique_id ?? null);
            
            }
              // desc_ts[0].s_status = row?.s_status
              // setDesc_Ts([]);
              // setM2mGraphArray([]);
            }
            else{
              setLiveData((prev:any)=>prev?.filter((item:any)=>item?.unique_id != row?.unique_id));
            }


            // if(liveData?.length ===1){//should be 0 now if length was 1



            // }

            // else{


            // }
          }
          

        
        }


        else{//executed tab
          handleNewRow(row);
          
        }


      }


      setLiveData((prev: any) => {
        const currentIndex = Array.isArray(prev) ? [...prev] : [];
        const updatedIndex = currentIndex.map((item) => {
          if (item?.unique_id === row?.unique_id) {
            return {
              ...item,
              trade_pl: row?.trade_pl,
              dt_date: moment(row?.dt_date).format("DD MMM YYYY"),
              dt_exit_time:  row?.dt_exit_time,
              n_exit_price:  row?.n_exit_price,
              n_pl: row?.n_pl,
              n_pl_rs: row?.n_pl_rs,
              n_return: row?.n_return,
              n_return_after_cost: row?.n_return_after_cost,
              s_status: row?.s_status,
              oneDayPl: row?.oneDayPl,
              oneDay_return_per: row?.onedayReturn,
              pl_with_dividend: row?.pl_with_dividend,
            };
          }
          return item;
        });
  
        return updatedIndex;
      });
  
      //allTrades
      setAllTradesData((prev: any) => {
        const currentIndex = Array.isArray(prev) ? [...prev] : [];
        const updatedIndex = currentIndex.map((item) => {
          if (item?.unique_id === row?.unique_id) {
            return {
              ...item,
              trade_pl: row?.trade_pl,
              dt_date: moment(row?.dt_date).format("DD MMM YYYY"),
              dt_exit_time:  row?.dt_exit_time,
              n_exit_price:  row?.n_exit_price,
              n_pl: row?.n_pl,
              n_pl_rs: row?.n_pl_rs,
              n_return: row?.n_return,
              n_return_after_cost: row?.n_return_after_cost,
              s_status: row?.s_status,
              oneDayPl: row?.oneDayPl,
              oneDay_return_per: row?.onedayReturn,
              pl_with_dividend: row?.pl_with_dividend,
            };
          }
          return item;
        });
  
        return updatedIndex;
      });




      }


      



    // if(row?.trade_category === "FNO"){
    //   setFilteredFNOData((prev: any) => {
    //     const currentIndex = Array.isArray(prev) ? [...prev] : [];
    //     const updatedIndex = currentIndex.map((item) => {
    //       if (item?.unique_id === row?.unique_id) {

    //         return {
    //           ...item,
    //           exit_price: row.exit_price,
    //           trade_pl: row.trade_pl,
    //           dt_date: moment(row?.dt_date).format("DD MMM YYYY"),
    //           dt_exit_time: row?.dt_exit_time,
    //           n_exit_price: row?.n_exit_price,
    //           n_pl: row?.n_pl,
    //           n_pl_rs: row?.n_pl_rs,
    //           n_return: row?.n_return,
    //           n_return_after_cost: row?.n_return_after_cost,
    //           s_status: row.s_status,

    //         };
    //       }
    //       return item;
    //     });
    //     return updatedIndex;
    //   });
    // }

    // if(row?.trade_category === "LFT"){
    //   setFilteredLFTData((prev: any) => {
    //     const currentIndex = Array.isArray(prev) ? [...prev] : [];
    //     const updatedIndex = currentIndex.map((item) => {
    //       if (item?.unique_id === row?.unique_id) {
  
    //         return {
    //           ...item,
    //           exit_price: row.exit_price,
    //           trade_pl: row.trade_pl,
    //           dt_date: moment(row?.dt_date).format("DD MMM YYYY"),
    //           dt_exit_time:  row?.dt_exit_time,
    //           n_exit_price: row?.n_exit_price,
    //           n_pl: row?.n_pl,
    //           n_pl_rs: row?.n_pl_rs,
    //           n_return: row?.n_return,
    //           n_return_after_cost: row?.n_return_after_cost,
    //           s_status: row.s_status,
        
    //         };
    //       }
    //       return item;
    //     });
    //     return updatedIndex;

    //   });
    // }

    // if(row?.trade_category === "OPT LONG"){
    //   setFilteredOptLongData((prev: any) => {
    //     const currentIndex = Array.isArray(prev) ? [...prev] : [];
    //     const updatedIndex = currentIndex.map((item) => {
    //       if (item?.unique_id === row?.unique_id) {

    //         return {
    //           ...item,
    //           exit_price: row.exit_price,
    //           trade_pl: row.trade_pl,
    //           dt_date: moment(row?.dt_date).format("DD MMM YYYY"),
    //           dt_exit_time: row?.dt_exit_time,
    //           n_exit_price: row?.n_exit_price,                
    //           n_pl: row?.n_pl,
    //           n_pl_rs: row?.n_pl_rs,
    //           n_return: row?.n_return,
    //           n_return_after_cost: row?.n_return_after_cost,
    //           s_status:  row.s_status,

    //         };
    //       }
    //       return item;
    //     });

    //     return updatedIndex;
    //   });
    // }

    // if(row?.trade_category === "EQ"){
    //   setFilteredEQData((prev: any) => {
    //     const currentIndex = Array.isArray(prev) ? [...prev] : [];
    //     const updatedIndex = currentIndex.map((item) => {
    //       if (item?.unique_id === row?.unique_id) {

    //         return {
    //           ...item,
    //           exit_price: row.exit_price,
    //           trade_pl: row.trade_pl,
    //           dt_date: moment(row?.dt_date).format("DD MMM YYYY"),
    //           dt_close_date : row.dt_close_date === ''? '': moment(row?.dt_close_date).format("DD MMM YYYY"),
    //           dt_exit_time:  row?.dt_exit_time,
    //           n_exit_price: row?.n_exit_price,                
    //           n_pl: row?.n_pl,
    //           n_pl_rs: row?.n_pl_rs,
    //           n_return: row?.n_return,
    //           n_return_after_cost: row?.n_return_after_cost,
    //           s_status:  row.s_status,
    //           oneDayPl: row?.oneDayPl,
    //           oneDay_return_per: row?.onedayReturn,
    //           pl_with_dividend: row?.pl_with_dividend,
 
    //         };
    //       }
    //       return item;
    //     });

    //     return updatedIndex;
    //   });
    // }

    // if(row?.trade_category === "EqN50plus"){
    //   setFilteredEqN50Data((prev: any) => {
    //     const currentIndex = Array.isArray(prev) ? [...prev] : [];
    //     const updatedIndex = currentIndex.map((item) => {
    //       if (item?.unique_id === row?.unique_id) {

    //         return {
    //           ...item,
    //           exit_price: row.exit_price,
    //           trade_pl: row.trade_pl,
    //           dt_date: moment(row?.dt_date).format("DD MMM YYYY"),
    //           dt_close_date :  row.dt_close_date === ''? '': moment(row?.dt_close_date).format("DD MMM YYYY"),
    //           dt_exit_time:    row?.dt_exit_time,
    //           n_exit_price: row?.n_exit_price,                
    //           n_pl: row?.n_pl,
    //           n_pl_rs: row?.n_pl_rs,
    //           n_return: row?.n_return,
    //           n_return_after_cost: row?.n_return_after_cost,
    //           s_status:  row.s_status,
    //           oneDayPl: row?.oneDayPl,
    //           oneDay_return_per: row?.onedayReturn,
    //           pl_with_dividend: row?.pl_with_dividend,
    
    //         };
    //       }
    //       return item;
    //     });
    //     // tempArr = tempArr.concat(filteredFNOData,filteredLFTData,filteredOptLongData,filteredEQData,[updatedIndex,...prev]);

    //     return updatedIndex;
    //   });
    // }





const liveTsChanges = (data:any)=>{
    
  let cookiesCodesArr: any = Cookies.get('codesArray') || []
  if (JSON.parse(cookiesCodesArr)?.includes(data?.s_code)) {
    const { s_code,dt_date, time, target, stoploss, s_option_type, n_strike_price, dt_expiry_date, row_unique_id, dt_exit_time, s_status, model_type }:any = data;

    if (row_unique_id === desc_ts[0]?.row_unique_id) {
      let newTslObj = {};
   
      if (target && stoploss) {
       newTslObj = {time,target,stoploss}
      }
      if (target === undefined || null) {
        newTslObj = {time,stoploss}
      }
      if (stoploss === undefined || null) {
        newTslObj = {time,target}

      }
      setDesc_Ts((prev:any) => {
        const updatedState = prev?.map((item:any) => ({
          ...item,
          s_status,
          dt_date, 
          tsl_arr: [newTslObj, ...item.tsl_arr], // Add new object to the beginning of tsl_arr
        }));
        return updatedState;
      });
    
};
}

}

const m2mGenerator = (data:any)=>{

    //For getting the real time pl from backend
    if(selectedTradeId === data?.unique_id){
      setM2mGraphArray((prevData: any) => {
        // Create a new array with the updated data instead of mutating the original array
        let updatedData = [...prevData, data?.pl];
        return updatedData; // Return updated data for state
      });
    }
  
}

const findStrength = async(today:boolean)=>{
  const filterDropdownVersion:Array<string> = [today? desc_ts[0]?.s_code.slice(0, -1) || "": backdatedDesc_ts[0]?.identifier.slice(0, -1) || "",];
  const plPercentApiResponse:any = await getPLPercentageResponse(startandEndDate.start_date,startandEndDate.end_date,"equityMultiday","all","equityMultiday","Total",filterDropdownVersion,"reInvestment");
  
  let strengthReason:string  = "";
  if (plPercentApiResponse.length > 0) {
    const returnPercent:number = Number(plPercentApiResponse[0]?.pl_percentage || 0);
    if (returnPercent < 21) strengthReason = "Conservative";
    else if (returnPercent <= 30) strengthReason = "Normal";
    else if (returnPercent > 30) strengthReason = "Aggressive";
    setStockStrength(strengthReason);
  }
  return strengthReason;
}

const findStrengthBank = async(today:boolean)=>{
  const filterDropdownVersion:Array<string> = [today? desc_ts[0]?.s_code.slice(0, -1) || "": backdatedDesc_ts[0]?.identifier.slice(0, -1) || "",];
  const plPercentApiResponse:any = await getPLPercentageResponse(startandEndDate.start_date,startandEndDate.end_date,"equityN50BANK","all","equityN50BANK","Total",filterDropdownVersion,"reInvestment");
  console.log("This is the PL Percent API Response:", plPercentApiResponse);
  let strengthReason:string  = "";
  if (plPercentApiResponse.length > 0) {
    const returnPercent:number = Number(plPercentApiResponse[0]?.pl_percentage || 0);
    if (returnPercent < 21) strengthReason = "Conservative";
    else if (returnPercent <= 30) strengthReason = "Normal";
    else if (returnPercent > 30) strengthReason = "Aggressive";
    setStockStrength(strengthReason);
  }
  return strengthReason;
}

//initial calculations for the first time (return container and return sidebar)
const initReturnSetter = (latestData:any[])=>{
    const rightSideReturn: any = getModalReturns(latestData);
    const todayReturnCalculator: any = returnCalculator(latestData, selectedModels, null, selectedDate);
    dispatch(setReturnCalculator(todayReturnCalculator));
    setModalReturns(rightSideReturn)
    const getInitSuccessRatio = initSuccessRatio(latestData)
    setSuccessRatio(getInitSuccessRatio)
    
    dispatch(setRightSidebarReturn(rightSideReturn))
    dispatch(setSuccessRatioData(getInitSuccessRatio))
}

// Fetch the data from backend and filter it according to Buttons FNO , LFT, EQ
const [getTrades, { error,loading:tradeLoading }]:any = useLazyQuery(GET_ALL_TRADES, {
  fetchPolicy: "network-only",
  onCompleted: (data: any) => {
    
    try {

      if (error) console.log("error while fetching all data",error);

      // setTradeCount({FNO: 0,LFT: 0,EQ: 0,EqN50plus: 0,OPT_LONG: 0});

      const latestData = data?.getTrades?.map((obj: any) => ({
        ...obj,
        s_symbol: obj.s_symbol,
        s_code: modelCodeMaking(obj),
        s_trade_type: obj.s_trade_type,
        n_transaction: obj?.s_code === 'AIONIFKKI' ? Number(obj?.n_transaction)?.toFixed(2) : Number(obj.n_transaction)?.toFixed(2),
        dt_date: moment(obj?.dt_date).format("DD MMM YYYY"),
        dt_close_date: (obj?.s_status === "" || obj?.s_status === null || (obj?.s_status)?.toUpperCase() === 'OPEN') ? '' : moment(obj?.dt_close_date).format("DD MMM YYYY"),
        n_exit_price: obj.n_exit_price === null ? "" : (obj?.s_code === 'AIONIFKKI' ? Number(obj?.n_exit_price)?.toFixed(2): Number(obj.n_exit_price)?.toFixed(2)),
        dt_entry_time: obj.dt_entry_time,
        dt_exit_time: (obj?.s_status === "" || obj?.s_status === null || (obj?.s_status)?.toUpperCase() === 'OPEN') ? '': obj.dt_exit_time,
        s_status: obj?.s_status === "" || obj?.s_status === null ? "Open" : toTitleCase(obj?.s_status),
        pl_with_dividend: (obj?.j_dividend?.length > 0) ? Number(obj?.n_pl + Number(obj?.pl_with_dividend)) : Number(obj?.n_pl),
        j_target_stoploss: obj?.j_target_stoploss?.map((item: any) => {
          const target = item?.Target;
          const stoploss = item?.Stoploss;
          const mappedItem: any = {
            s_symbol: obj.s_symbol,
            s_code: obj.s_code,
            time: item?.time,
          };

          if (target !== null) {
            mappedItem.Target = target;
          }
          if (stoploss !== null) {
            mappedItem.Stoploss = stoploss;
          }
          return mappedItem;
        }),
        unique_id: `${obj?.s_code}_${moment(obj?.dt_date).format("YYYY-MM-DD")}_${obj?.dt_entry_time}_${obj?.n_id}`,
      }));
      
      
      setLiveData(latestData);
      
      if(adviceType === "FNO" && latestData?.length > 0) {
        setFilteredParameters(latestData[0]);
        getM2MArray({
          variables:{
            uniqueId: latestData[0]?.unique_id
          }
         
        })
      }
      else if(adviceType === "LFT" && latestData?.length > 0) { 
        setFilteredParameters(latestData[0]);
        getM2MArray({
          variables:{
            uniqueId: latestData[0]?.unique_id
          }
         
        })
        
      }
      else if(adviceType === "OPT LONG" && latestData?.length > 0) {  
        setFilteredParameters(latestData[0]);
        getM2MArray({
          variables:{
            uniqueId: latestData[0]?.unique_id
          }
         
        })
      }
      else if(adviceType === "EQ" && latestData?.length > 0) {
        setFilteredParameters(latestData[0]);
        getM2MArray({
          variables:{
            uniqueId: latestData[0]?.unique_id
          }
         
        })
      }
      else if(adviceType === "EqN50plus" && latestData?.length > 0) {
        setFilteredParameters(latestData[0]);
        getM2MArray({
          variables:{
            uniqueId: latestData[0]?.unique_id
          }
         
        })
      }
      else if(adviceType === "EqBANK" && latestData?.length > 0) {
        setFilteredParameters(latestData[0]);
        getM2MArray({
          variables:{
            uniqueId: latestData[0]?.unique_id
          }
         
        })
      }
      else{
        setFilteredParameters([]);
        setM2mGraphArray([]);
      }
      

    } catch (error) {
      console.log("error while fetching from graphql...",error);
    }
  }
  ,
});

const [getTotalTrades, { error:totalTradesError,loading:TotaltradeLoading }]:any = useLazyQuery(GET_TOTAL_TRADES, {
  fetchPolicy: "network-only",
  onCompleted: (data: any) => {
    
    try {

      if (error) console.log("error while fetching all data",error);

      // setTradeCount({FNO: 0,LFT: 0,EQ: 0,EqN50plus: 0,OPT_LONG: 0});

      const latestData = data?.getTotalTrades?.map((obj: any) => ({
        ...obj,
        s_symbol: obj.s_symbol,
        s_code: modelCodeMaking(obj),
        s_trade_type: obj.s_trade_type,
        n_transaction: obj?.s_code === 'AIONIFKKI' ? Number(obj?.n_transaction)?.toFixed(2) : Number(obj.n_transaction)?.toFixed(2),
        dt_date: moment(obj?.dt_date).format("DD MMM YYYY"),
        dt_close_date: (obj?.s_status === "" || obj?.s_status === null || (obj?.s_status)?.toUpperCase() === 'OPEN') ? '' : moment(obj?.dt_close_date).format("DD MMM YYYY"),
        n_exit_price: obj.n_exit_price === null ? "" : (obj?.s_code === 'AIONIFKKI' ? Number(obj?.n_exit_price)?.toFixed(2): Number(obj.n_exit_price)?.toFixed(2)),
        dt_entry_time: obj.dt_entry_time,
        dt_exit_time: (obj?.s_status === "" || obj?.s_status === null || (obj?.s_status)?.toUpperCase() === 'OPEN') ? '': obj.dt_exit_time,
        s_status: obj?.s_status === "" || obj?.s_status === null ? "Open" : toTitleCase(obj?.s_status),
        pl_with_dividend: (obj?.j_dividend?.length > 0) ? Number(obj?.n_pl + Number(obj?.pl_with_dividend)) : Number(obj?.n_pl),
        unique_id: `${obj?.s_code}_${moment(obj?.dt_date).format("YYYY-MM-DD")}_${obj?.dt_entry_time}_${obj?.n_id}`,
      }));
      
      setAllTradesData(latestData); //alltrades
      initReturnSetter(latestData); //return calculator
      

    } catch (error) {
      console.log("error while fetching total trades from graphql...",error);
      setAllTradesData([]);
    }
  }
  ,
});

const [getOnlyTS,{loading}]:any = useLazyQuery(GET_ONLY_TARGET_STOPLOSS, {
  fetchPolicy: "network-only",
  onCompleted: (Data: any) => {
    const arr:any       = [];
    const tsl_arr:any   = [];
    
    //Changes have added for target stoploss
    let uniqueIdDate:any = ['ES', 'OL']?.includes(Data?.getOnlyTS[0]?.s_code?.slice(1,3)) ? (Data?.getOnlyTS[0]?.dt_date) : (new Date())?.toISOString()?.slice(0, 10)
    const row_unique_id = `${(Data?.getOnlyTS[0]?.s_code)?.slice(0,-1)}_${String(uniqueIdDate)}_${Data?.getOnlyTS[0]?.dt_entry_time}_${Data?.getOnlyTS[0]?.n_id}`;


    const dt_exit_time    = Data?.getOnlyTS[0]?.dt_exit_time
    const s_option_type   = Data?.getOnlyTS[0]?.s_option_type
    const s_status        = Data?.getOnlyTS[0]?.s_status
    const n_strike_price  = Data?.getOnlyTS[0]?.n_strike_price
    const dt_expiry_date  = Data?.getOnlyTS[0]?.dt_expiry_date
    const dt_date         = Data?.getOnlyTS[0]?.dt_date
    const model_type      = Data?.getOnlyTS[0]?.model_type //new added
    const s_symbol        = Data?.getOnlyTS[0]?.s_symbol
    const s_code          = Data?.getOnlyTS[0]?.s_code
    const entryPoint      = Data?.getOnlyTS[0]?.dt_entry_time


    arr[0]={entryPoint,row_unique_id,dt_exit_time,s_option_type,s_status,n_strike_price,dt_expiry_date,dt_date,model_type,s_symbol,s_code}
    let j_dividend_arr: any = []
    if (Data?.getOnlyTS[0]?.j_dividend?.length > 0) {
      Data?.getOnlyTS[0]?.j_dividend?.map((item: any) => {
        return j_dividend_arr.unshift({
          date: item?.date,
          value: item?.value
        })
      })
    }

    Data?.getOnlyTS[0]?.j_target_stoploss?.map((elem: any) => {
      //descending the target stoploss payload
      if (elem?.target !== 0 && elem?.stoploss !== 0) {
        tsl_arr.unshift({
          time: elem?.time,
          target: elem?.target,
          stoploss: elem?.stoploss,
        });
      }
      if (elem?.target === 0) {
        tsl_arr.unshift({
          time: elem?.time,
          stoploss: elem?.stoploss,
        });
      }
      if (elem?.stoploss === 0) {
        tsl_arr.unshift({
          time: elem?.time,
          target: elem?.target,
        });
      }
    });
    arr[0]={...arr[0],tsl_arr,j_dividend_arr};
    
    setDesc_Ts(arr);

  },
});

//New added for charts
const [getM2MArray,{loading:m2mArrayLoading }]:any = useLazyQuery(GET_M2M_ARRAY, {
  fetchPolicy: "no-cache",
  onCompleted:(Data:any)=>{    
    if(Data?.getM2MArray){

      setM2mGraphArray([])
      setSelectedTradeId(()=>{return Data?.getM2MArray?.uniqueId})
      setM2mGraphArray(()=>{return Data?.getM2MArray?.m2mArray})
    }
    else{
      setSelectedTradeId('');
      setM2mGraphArray([]);
    }
  }
});

const [getTradeCount,{error:tradeCountError}]:any = useLazyQuery(GET_TRADE_COUNT,{
  fetchPolicy: "network-only",
  onCompleted:(Data:any)=>{
    
    if(tradeCountError) {
    setTradeCount({FNO:0,LFT:0,OPT_LONG:0,EQ:0,EqN50plus:0, EqBANK:0, EqIT:0});
    console.log("Error occured while fetching trade count",error);
    
    }
    setTradeCount(Data?.getTradeCount);
  }
})

const backDatedTradeResponse: any = async () => {
  setLiveOverAllData([])
  try {
    const currentDate:any = new Date();
    if (selectedDate === moment(currentDate).format("YYYY-MM-DD")) {
      getTrades({
        variables: {
          username: getUserMail(),
          tab: activeTab,
          tradeCategory:adviceType === "OPT LONG" ? "OPT_LONG" :adviceType,
          startIndex:activeTab === "Live" ? 0 :first

        },
      })

      return
    }
    else {
      
      setLiveBtn(false);
      setLoader(true);
     
      const { data } = await axios.post(liveOverAllAdviceStatus,{ username: getUserMail(), selectedDate: selectedDate })
      let backdatedData: any = backdatedParamsSet(data)
      const backDatedReturnModel = backDatedGetModalReturns(data?.final_response)
      dispatch(setRightSidebarReturn(backDatedReturnModel))
      const backDatedSuccessRatio = backdatedInitSuccessRatio(data?.final_response);
      dispatch(setSuccessRatioData(backDatedSuccessRatio))
      setSuccessRatio(backDatedSuccessRatio)
      const todayReturnCalculator: any = returnCalculator(data?.final_response, selectedModels, null, selectedDate)
      dispatch(setReturnCalculator(todayReturnCalculator))

      const temp:any[] = backdatedData?.map((item: any) => {
        return {
          ...item,
          asset: ((item?.identifier)?.slice(0,-1) === 'AIONIFKKI') ? item?.asset?.split("-")[0] : item?.asset?.split("-")[0],
          exit_price: (item?.identifier?.slice(0,-1) === "AIONIFKKI") ? item?.exit_price?.toFixed(4) :item?.exit_price?.toFixed(2),
          trade_pl: item?.trade_pl?.toFixed(2),
          trade_pl_rs: item?.trade_pl_rs?.toFixed(2),
          return_per: item?.return_per?.toFixed(4),
          return_after_cost: item?.return_after_cost?.toFixed(4),
          s_reason: (item?.s_reason !== null && item?.s_reason !== "")? toTitleCase(item?.s_reason) : 'Open',
          n_open_transaction_price: (item?.identifier?.slice(0,-1) === "AIONIFKKI") ? item?.n_open_transaction_price.toFixed(2) : item?.n_open_transaction_price.toFixed(2),
          open_date: moment(item?.open_date).format("DD MMM YYYY") ,
          trade_close_date : (item?.s_reason !== null && item?.s_reason !== '') ? moment(item?.trade_close_date).format("DD MMM YYYY") : '',
          dt_end_time : (item?.s_reason !== null && item?.s_reason !== '') ? item?.dt_end_time : '',
          unique_id :`${(item?.identifier)?.slice(0,-1)}_${item?.open_date}_${item?.dt_open_time}`
        }
      })        
      setLiveOverAllData(temp);
      setLoader(false);

      const fno_arr:any[] = temp?.filter((item:any)=>(item?.trade_category === "FNO"));
      
      
      setBackdatedFilteredFNOData(fno_arr);

      const params: any = backdatedParamsSet1(fno_arr[0] ?? undefined)
      setBackdatedDesc_Ts(params);


      const lft_arr:any[] = temp?.filter((item:any)=>(item?.trade_category === "LFT"));
      setBackdatedFilteredLFTData(lft_arr);

      const optLong_arr:any[] = temp?.filter((item:any)=>(item?.trade_category === "OPT LONG"));
      setBackdatedFilteredEQData(optLong_arr);

      const eq_arr:any[] = temp?.filter((item:any)=>(item?.trade_category === "EQ"));
      setBackdatedFilteredEQData(eq_arr);

      const eqnxt50_arr:any[] = temp?.filter((item:any)=>(item?.trade_category === "EqN50plus"));
      setBackdatedFilteredEQData(eqnxt50_arr);

      const eqbank_arr:any[] = temp?.filter((item:any)=>(item?.trade_category === "EqBANK"));
      setBackdatedFilteredEQData(eqbank_arr);

      const eqit_arr:any[] = temp?.filter((item:any)=>(item?.trade_category === "EqIT"));
      setBackdatedFilteredEQData(eqit_arr);

      setTradeCount(
        {
          FNO: fno_arr?.length ?? 0,
          LFT: lft_arr?.length ?? 0,
          EQ: eq_arr?.length ?? 0,
          EqN50plus: eqnxt50_arr?.length ?? 0,
          OPT_LONG: optLong_arr?.length ?? 0,
          EqBANK: eqbank_arr?.length ?? 0,
          EqIT: eqit_arr?.length ?? 0,
        }
      )
    }
  } catch (error) {
    console.log("Excepction occured while fetching back dated data in live page : ", error);
  }
}

const setFilteredParameters = (newdataTsData: any) => {
  
  if (Object.keys(newdataTsData)?.length === 0 || newdataTsData === undefined || newdataTsData === null) {
    setDesc_Ts([]);
    return;
  }
  let productCode:any = '';
  if((newdataTsData?.s_code)?.includes('-') == true) {
    productCode = (newdataTsData?.s_code)?.split('-')[0]?.slice(0, -1) +'-'+(newdataTsData?.s_code)?.split('-')[1]
  }else{
    productCode = (newdataTsData?.s_code)?.split('-')[0]?.slice(0, -1)
  } 
    getOnlyTS({
      variables: {
        dtDate: moment(newdataTsData?.dt_date)?.format("YYYY-MM-DD"),
        dtEntryTime: newdataTsData?.dt_entry_time,
        sCode: productCode,
      },

    });

};

//csv download
const generateCSVData = (filteredData: any[], isBackdated: boolean, filenamePrefix: string) => {
  if (!filteredData) return;

  let arr: any[] = [];
  filteredData.map((item: any) => {
    const targetSlJson = isBackdated
      ? backdatedCSVTargetSlNormalizer(item?.targetStoploss)
      : csvTargetSlNormalize(item?.j_target_stoploss);

      const tradeData:any = {
        "s_code": item?.s_code || item?.identifier,
        "s_symbol": item?.s_symbol || item?.asset,
        "OpenDate": item?.dt_date || item?.open_date,
        "OpenTime": item?.dt_entry_time || item?.dt_open_time,
        "Trade Type": item?.s_trade_type || item?.trade_type,
        "Target": targetSlJson['Target'],
        "Stoploss": targetSlJson['Stoploss'],
        "Transaction": item?.n_transaction || item?.n_open_transaction_price,
        "Exit Price": item?.n_exit_price || item?.exit_price,
        "P/L": item?.n_pl || item?.trade_pl,
        "P/L (₹)": item?.n_pl_rs || item?.trade_pl_rs,
        "Return": Number(item?.n_return || item?.return_per)?.toFixed(4),
        "Return After Cost (%)": Number(item?.n_return_after_cost || item?.return_after_cost)?.toFixed(4),
        "Status": item?.s_status || item?.s_reason,
        "TargetSlJson": targetSlJson['TargetStoplossJson'],
      };
      
      // Add fields conditionally
      if (!["EQ", "EqN50plus"].includes(adviceType)) {
        tradeData["CloseDate"] = (item?.dt_close_date || item?.trade_close_date) ?? '';
        tradeData["CloseTime"] = item?.dt_exit_time || item?.dt_end_time;
        tradeData["Oneday PL"] = item?.oneDaypl || '';
        tradeData["Oneday Return"] = item?.oneDay_return_per || '';
        tradeData["Oneday Return After Cost"] = item?.oneDayReturnAfterCost || '';
      }
      
      arr.push(tradeData);
  });

  const dataToConvert = {
    data: arr,
    filename: `${filenamePrefix}_trades_for_${moment(selectedDate).format('YYYY-MM-DD')}`,
    delimiter: ",",
    headers: [
      "s_code",
      "s_symbol",
      "Open Date",
      "Close Date",
      "Open Time",
      "Close Time",
      "Trade Type",
      "Target",
      "Stoploss",
      "Transaction",
      "Exit Price",
      "P/L",
      "P/L (₹)",
      "Return",
      "Return After Cost (%)",
      "Status",
      "Oneday PL",
      "Oneday Return",
      "Oneday Return After Cost",
      "Target Stoploss Json"
    ].filter(Boolean), // Remove undefined headers for cases without "Close Date" or "Oneday PL"
  };

  csvDownload(dataToConvert);
};

const csvDataMaker = (e: any) => {
  e.preventDefault();

  const isToday = selectedDate === moment(new Date()).format("YYYY-MM-DD");
  const isBackdated = !isToday;

  const dataMapping: Record<string, any> = isBackdated
    ? {
        "FNO": BackdatedFilteredFNOData,
        "LFT": BackdatedFilteredLFTData,
        "EQ": BackdatedFilteredEQData,
        "EqN50plus": BackdatedFilteredEqN50Data,
        "OPT LONG": BackdatedFilteredOptLongData,
      }
    : {
        "FNO": liveData,
        "LFT": liveData,
        "EQ": liveData,
        "EqN50plus": liveData,
        "OPT LONG": liveData,
      };

  if (dataMapping[adviceType]) {
    generateCSVData(dataMapping[adviceType], isBackdated, adviceType.replace(" ", "_"));
  }
};

const handlePagination = (e:any)=>{
  debouncedPagination(e);
}

const debouncedPagination = useCallback(
  debounce((e: any) => {
    setFirst(e?.first);
    const currentDate:any = new Date();
    if (selectedDate === moment(currentDate).format("YYYY-MM-DD")) {

      getTrades({
        variables: {
          username: getUserMail(),
          tab: activeTab,
          tradeCategory:adviceType === "OPT LONG" ? "OPT_LONG" :adviceType,
          startIndex:activeTab === "Live" ? 0 : e?.first
        },
      });
    }
  }, 300), 
  [activeTab,adviceType] 
);


const filteringDataOnAdviceTypeClicking = useCallback(
  debounce((text: any) => {
        if (text === "FNO") {
      setAdviceType("FNO");
      setViewSTOCKCharts(false);
     setSelectedPreviewTableData(BackdatedFilteredFNOData)
    }
    else if (text === "LFT") {
      setAdviceType("LFT");
      setViewSTOCKCharts(false);
      setSelectedPreviewTableData(BackdatedFilteredLFTData)

    }
    else if (text === "EQ") {
      setAdviceType("EQ");
      setViewSTOCKCharts(true)
      document.getElementById('stock_chart')?.scrollIntoView({behavior:'smooth',block:'end' });
      setSelectedPreviewTableData(BackdatedFilteredEQData)
    
    }
    else if (text === "EqN50plus") {
      setAdviceType("EqN50plus");
      setViewSTOCKCharts(true)
      document.getElementById('stock_chart')?.scrollIntoView({behavior:'smooth',block:'end' });
      setSelectedPreviewTableData([])
   
    }
    else if (text === "OPT LONG") {
      setAdviceType("OPT LONG");
      setViewSTOCKCharts(false);
      setSelectedPreviewTableData(BackdatedFilteredOptLongData)
    
    }
    else if (text === "EqBANK") {
      setAdviceType("EqBANK");
      setViewSTOCKCharts(false);
      setSelectedPreviewTableData(BackdatedFilteredOptLongData)
    
    }
  },500),[adviceType]
)



const onRowSelect = (event: any) => {

  //New added for charts
  getM2MArray({
    variables:{
      uniqueId: event?.data?.unique_id
    }
    
  })





  let productCode:any = '';
  if((event.data?.s_code)?.includes('-') == true) {
    productCode = (event.data?.s_code)?.split('-')[0]?.slice(0, -1) +'-'+(event.data?.s_code)?.split('-')[1]
  }else{
    productCode = (event.data?.s_code)?.split('-')[0]?.slice(0, -1)
  }  

  getOnlyTS({
    variables: {
      dtDate: moment(event.data?.dt_date)?.format("YYYY-MM-DD"),
      dtEntryTime: event.data?.dt_entry_time,
      sCode:  productCode,
    },
  });

};

//Replace for charts
const onRowSelectBackdated = (event: any) => {
  setM2mGraphArray(calculate_m2m_graph(event?.data?.m2m_array, ' '))
  const params = backdatedParamsSet1(event?.data)
  setBackdatedDesc_Ts(params)
}


const activeTrade = (item: any) => {
  if (item?.s_status === null || item?.s_status === '' || item?.s_status === 'Open') {
    return 'openTrade'
  }
}

const backDatedActiveTrade = (item: any) => {
  if (item?.s_reason === undefined || item?.s_reason === null || item?.s_reason === '' || item?.s_reason === 'Open') {
    return 'openTrade'
  }
}

const onColumnToggle = (event: any) => {
  let selectedColumns = event.value;
  // let orderedSelectedColumns = columns.filter((col: any) =>
  //   selectedColumns.some((sCol: any) => sCol.field === col.field)
  // );
  let orderedSelectedColumns = selectedColumns.filter((col: any) =>
    columns.some((sCol: any) => sCol.field === col.field)
  );
  setVisibleColumns(orderedSelectedColumns);
  setOrderedCol(orderedSelectedColumns)
};

const onBackdatedColumnToggle = (event: any) => {
  let selectedColumns = event.value;
  // let orderedSelectedColumns = backdatedColumns.filter((col: any) =>
  //   selectedColumns.some((sCol: any) => sCol.field === col.field)
  // );
  let orderedSelectedColumns = selectedColumns.filter((col: any) =>
    backdatedColumns.some((sCol: any) => sCol.field === col.field)
  );
  setBackdatedVisibleColumns(orderedSelectedColumns);
  setOrderedCol(orderedSelectedColumns)
  
};

const onOptLongColumnToggle = (event: any) => {
  let selectedColumns = event.value;
  // let orderedSelectedColumns = columns.filter((col: any) =>
  //   selectedColumns.some((sCol: any) => sCol.field === col.field)
  // );
  let orderedSelectedColumns = selectedColumns.filter((col: any) =>
    columns.some((sCol: any) => sCol.field === col.field)
  );
  setOptLongVisibleColumns(orderedSelectedColumns);
  setOrderedCol(orderedSelectedColumns)
};

const onOptLongBackdatedColumnToggle = (event: any) => {
  let selectedColumns = event.value;
  // let orderedSelectedColumns = backdatedColumns.filter((col: any) =>
  //   selectedColumns.some((sCol: any) => sCol.field === col.field)
  // );
  let orderedSelectedColumns = selectedColumns.filter((col: any) =>
    backdatedColumns.some((sCol: any) => sCol.field === col.field)
  );
  setBackdatedVisibleColumns(orderedSelectedColumns);
  setbackdatedOptLongVisibleColumns(orderedSelectedColumns);
  setOrderedCol(orderedSelectedColumns)
};

const EqOnColumnToggle = (event: any) => {
  let selectedColumns = event.value;
  // let orderedSelectedColumns = equity_columns.filter((col: any) =>
  //   selectedColumns.some((sCol: any) => sCol.field === col.field)
  // );
  let orderedSelectedColumns = selectedColumns.filter((col: any) =>
    equity_columns.some((sCol: any) => sCol.field === col.field)
  );
  setEqVisibleColumns(orderedSelectedColumns);
  setOrderedColEq(orderedSelectedColumns)
};

const EqN50OnColumnToggle = (event: any) => {
  let selectedColumns = event.value;
  // let orderedSelectedColumns = equityN50_columns.filter((col: any) =>
  //   selectedColumns.some((sCol: any) => sCol.field === col.field)
  // );
  let orderedSelectedColumns = selectedColumns.filter((col: any) =>
    equityN50_columns.some((sCol: any) => sCol.field === col.field)
    );
  setEqN50VisibleColumns(orderedSelectedColumns);
  setOrderedColEq(orderedSelectedColumns)
};

const OnbackdatedEqColumnToggle = (event: any) => {
  let selectedColumns = event.value;
  // let orderedSelectedColumns = backdatedEquityColumns.filter((col: any) =>
  //   selectedColumns.some((sCol: any) => sCol.field === col.field)
  // );
  let orderedSelectedColumns = selectedColumns.filter((col: any) =>
    backdatedEquityColumns.some((sCol: any) => sCol.field === col.field)
  );
  setBackdatedeqVisibleColumnsState(orderedSelectedColumns);
  setOrderedColEq(orderedSelectedColumns)
};

const OnbackdatedEqN50ColumnToggle = (event: any) => {
  let selectedColumns = event.value;
  // let orderedSelectedColumns = backdatedEquityN50Columns.filter((col: any) =>
  //   selectedColumns.some((sCol: any) => sCol.field === col.field)
  // );
  let orderedSelectedColumns = selectedColumns.filter((col: any) =>
    backdatedEquityN50Columns.some((sCol: any) => sCol.field === col.field)
  );
  setBackdatedeqN50VisibleColumnsState(orderedSelectedColumns);
  setOrderedColEq(orderedSelectedColumns)
};

const saveColOrder = async (colReorder: any, type: any) => {
  let user_mail = getUserMail()
  await saveColumnOrder(colReorder, user_mail, type)
  getColOrder()
}

const getColOrder = async () => {
  let user_mail = getUserMail()
  let response = await getColumnOrder(user_mail)
  if(response !== undefined && response !== null ){
    setOrderedCol([response][0]['opt'])
    setOrderedColEq([response][0]['equity'])
  }
}

const onColumnDrag = (event: any, dropIndex: any) => {

  let colReorder: any = []
  let presentInEq = false
  let totalEq :any = orderedColEq

  event.map((item: any, index: any) => {
    colReorder.push({ field: event[index]?.['props']?.['field'], header: event[index]?.['props']?.['header'] })
  })
  colReorder.shift();
  setOrderedCol(colReorder)

  orderedColEq?.map((item: any, index:any) => {
    if(item.field == event[dropIndex]['props']['field'])
      presentInEq = true
  })

  if( presentInEq){

    totalEq = colReorder
    let index_list : any = []

    orderedColEq?.map((item:any, index:any)=>{
      if(['1D P/L', '1D Return(%)', 'Close Date'].includes(item.header))
      {
        index_list.push({field: item.field, header: item.header, index: index})
        totalEq.splice(index, 0 , {field: item.field, header: item.header})
      }
    })
    setOrderedColEq(totalEq)
  }
  
  let completeOrderedJson : any = {"opt" : colReorder, "equity": totalEq }
  saveColOrder(completeOrderedJson, 'opt')
}

const useTabInactivityReload = (timeout = 30000) => {
  useEffect(() => {
    let timer:any;

    const handleVisibilityChange = () => {
      if (document.hidden) {
        // Start the reload timer when tab is inactive
        timer = setTimeout(() => {
          window.location.reload();
        }, timeout);
      } else {
        // Clear timer if tab becomes active again
        clearTimeout(timer);
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      clearTimeout(timer);
    };
  }, [timeout]);
};


const onColumnDragEquity = (event: any, dropIndex: any ) => {

  let colReorder: any = []
  let presentInOpt = false
  let totalOpt :any = orderedCol

  event.map((item: any, index: any) => {
    colReorder.push({ field: event[index]['props']['field'], header: event[index]['props']['header'] })
  })
  colReorder.shift();


  orderedCol?.map((item: any, index:any) => {
    if(item.field == event[dropIndex]['props']['field'])
      presentInOpt = true
  })

    setOrderedColEq(colReorder)
  

  if( presentInOpt){

    totalOpt = []
    colReorder.filter((idx: any)=>(orderedCol?.map((item:any)=>{ 
      if( idx.header == item.header){
        totalOpt.push({field:item.field, header:item.header})
      }
    })))
    setOrderedCol(totalOpt)

  }
  let completeOrderedJson : any = {"opt" : totalOpt, "equity": colReorder}
  saveColOrder(completeOrderedJson, 'equity')

}

const getColumnDiv = (type:any, col:any, columnState : any) => {
  
  let data = ''
  columnState?.map((item:any) => {
  if(item?.header == col?.header)
    {
      data = item?.field
    }
  })
  return data
}

const header: any = (
  <>
    {selectedDate === moment(new Date()).format("YYYY-MM-DD") ?
        <div className="params_btn">
          <div className="buttons_group">
            <button
              className="btn_header"
              id={adviceType === "FNO" ? "selected" : ""}
              onClick={() => filteringDataOnAdviceTypeClicking("FNO")}
            >
              OPT S
              <Tooltip title='Total trades for today'>
              <span className="btn_header_length">({tradeCount.FNO})</span>
              </Tooltip>
            </button>
            <button
              className="btn_header"
              id={adviceType === "LFT" ? "selected" : ""}
              onClick={() => filteringDataOnAdviceTypeClicking("LFT")}
            >
              OPT S LFT
              <Tooltip title='Total trades for today'>
                <span className="btn_header_length">({tradeCount.LFT})</span>
              </Tooltip>
               
            </button>
            <button className="btn_header"
            id={adviceType === "OPT LONG" ? "selected" : ""}
            onClick={() => filteringDataOnAdviceTypeClicking("OPT LONG")}
              >
              OPT L
              <Tooltip title='Total trades for today'>
              <span className="btn_header_length">({tradeCount.OPT_LONG})</span>
              </Tooltip>
            </button>
            <button
              className="btn_header"
              id={adviceType === "EQ" ? "selected" : ""}
              onClick={() => filteringDataOnAdviceTypeClicking("EQ")}
            >
              EQ N50
              <Tooltip title='Total trades for today'>
              <span className="btn_header_length">({tradeCount.EQ})</span>
              </Tooltip>
             
            </button>
            <button
              className="btn_header"
              id={adviceType === "EqBANK" ? "selected" : ""}
              onClick={() => filteringDataOnAdviceTypeClicking("EqBANK")}
            >
              EQ BANK
              <Tooltip title='Total trades for today'>
              <span className="btn_header_length">({tradeCount.EqBANK})</span>
              </Tooltip>
             
            </button>

            {/* <button
              className="btn_header"
              id={adviceType === "EqN50plus" ? "selected" : ""}
              onClick={() => filteringDataOnAdviceTypeClicking("EqIT")}
            >
              TEST
              <Tooltip title='Total trades for today'>
              <span className="btn_header_length">({tradeCount.EqIT})</span>
              </Tooltip>
             
            </button> */}
          </div>
          <div className="table_option_div">
            <div className="table_options">
            <div className="toggle_btn_group">
      <div ref={activeRef} className="btn_slider"
      style={activeStyle}
      >

      </div>

      <span ref={liveBtnRef}
        className={`btn_live ${liveBtn ? "active" : ""}`}
        onClick={() => setActiveTab('Live')}
      >
        Live <span className="stat_live m-0"></span>
      </span>

      <span ref={executedBtnRef}
        className={`btn_executed ${!liveBtn ? "active" : ""}`}
        onClick={() => setActiveTab('Executed')}
      >
        Executed <FaBookBookmark />
      </span>
    </div>
             

              <span style={{ marginRight: "0.5rem" }} onClick={() => setMultiSelect(!multiSelect)}>
                <img src="icons/preference_icon.png" width="30px" height="30px" alt="preference" />
              </span>
              {adviceType === "EQ" || adviceType === "EqBANK" ?   
                <MultiSelect
                  value={orderedColEq}
                  options={equity_columns}
                  optionLabel="header"
                  onChange={EqOnColumnToggle}  
                  className="select_column"
                  filter
                  checked
                  placeholder="All"
                /> :adviceType === "EqN50plus" ?
                <MultiSelect
                  value={orderedColEq}
                  options={equityN50_columns}
                  optionLabel="header"
                  onChange={EqN50OnColumnToggle}
                  className="select_column"
                  filter
                  checked
                  placeholder="All"
                /> :
                adviceType === "OPT LONG" ?
                <MultiSelect
                value={orderedCol}
                options={optLong_columns}
                optionLabel="header"
                onChange={onOptLongColumnToggle}  //!!!!!!!!!
                className="select_column"
                filter
                checked
                placeholder="All"
              />:
                <MultiSelect
                  value={orderedCol}
                  options={columns}
                  optionLabel="header"
                  onChange={onColumnToggle}
                  className="select_column"
                  filter
                  checked
                  placeholder="All"
                />

              }
              <Tooltip zIndex={10000000} title="Download Csv">  
              
              <button 
                className="btn btn-sm btn-neutral mr-2"
                onClick={() =>{ 
                  selectedDate === moment(new Date()).format("YYYY-MM-DD") && setSelectedPreviewTableData(liveData);
                  setIsModalOpen(true)
                  
                }
                }
              >
                <i className="pi pi-download"></i>
              </button>
              </Tooltip>
            </div>
          </div>
        </div> :
        <div className="params_btn">
          <div className="buttons_group">
            <button
              className="btn_header"
              id={adviceType === "FNO" ? "selected" : ""}
              onClick={() => filteringDataOnAdviceTypeClicking("FNO")}
            >
              OPT S ({tradeCount.FNO})
            </button>
            <button
              className="btn_header"
              id={adviceType === "LFT" ? "selected" : ""}
              onClick={() => filteringDataOnAdviceTypeClicking("LFT")}
            >
              OPT S LFT ({tradeCount.LFT})
            </button>
            <button className="btn_header"
            id={adviceType === "OPT LONG" ? "selected" : ""}
            onClick={() => filteringDataOnAdviceTypeClicking("OPT LONG")}
              >
              OPT L<span className="btn_header_length">({tradeCount.OPT_LONG})</span>
            </button>
            <button
              className="btn_header"
              id={adviceType === "EQ" ? "selected" : ""}
              onClick={() => filteringDataOnAdviceTypeClicking("EQ")}
            >
              EQ N50 ({tradeCount.EQ})
            </button>
            {/* <button
              className="btn_header"
              id={adviceType === "EqN50plus" ? "selected" : ""}
              onClick={() => filteringDataOnAdviceTypeClicking("EqN50plus")}
            >
              EQ N50NXT ({tradeCount.EqN50plus})
            </button> */}

            <button
              className="btn_header"
              id={adviceType === "EqBANK" ? "selected" : ""}
              onClick={() => filteringDataOnAdviceTypeClicking("EqBANK")}
            >
              EQ BANK ({tradeCount.EqBANK})
            </button>
           
          </div>
          <div className="table_option_div">
            <div className="table_options">
            <div className="toggle_btn_group">
      <div ref={activeRef} className="btn_slider"
      style={activeStyle}
      >

      </div>

      <span ref={liveBtnRef}
        className={`btn_live ${liveBtn ? "active" : ""}`}
        onClick={() => setActiveTab('Live')}
      >
        Live <span className="stat_live m-0"></span>
      </span>

      <span ref={executedBtnRef}
        className={`btn_executed ${!liveBtn ? "active" : ""}`}
        onClick={() => setActiveTab('Executed')}
      >
        Executed <FaBookBookmark />
      </span>
    </div>

              <span onClick={() => setMultiSelect(!multiSelect)}>
                <img src="icons/preference_icon.png" width="30px" height="30px" alt="preference"/>
              </span>
              {adviceType === "EQ" || adviceType === "EqBANK" ?
                <MultiSelect
                  value={orderedColEq}
                  options={backdatedEquityColumns}
                  optionLabel="header"
                  onChange={OnbackdatedEqColumnToggle}  //!!!!!!!!!
                  className="select_column"
                  filter
                  checked
                  placeholder="All"
                />:adviceType === "EqN50plus" ?
                <MultiSelect
                  value={orderedColEq}
                  options={backdatedEquityN50Columns}
                  optionLabel="header"
                  onChange={OnbackdatedEqN50ColumnToggle}  //!!!!!!!!!
                  className="select_column"
                  filter
                  checked
                  placeholder="All"
                />
                : adviceType === "OPT LONG" ?
                <MultiSelect
                value={orderedCol}
                options={backdatedColumns}
                optionLabel="header"
                onChange={onOptLongBackdatedColumnToggle}
                className="select_column"
                filter
                checked
                placeholder="All"
              />:
                <MultiSelect
                  value={orderedCol}
                  options={backdatedColumns}
                  optionLabel="header"
                  onChange={onBackdatedColumnToggle}
                  className="select_column"
                  filter
                  checked
                  placeholder="All"
                />
              }
              <Tooltip zIndex={10000000} title="Download Csv">


              <button
                className="btn btn-sm btn-neutral mr-2"
                onClick={() =>{

                  setIsModalOpen(true);
                  // let tempData:any[] = selectDataBackDatedData(adviceType);
                  // LivePageHistocalexportCSV(false,tempData)
                
                }}
              >
                <i className="pi pi-download"></i>
              </button>
              </Tooltip>
            </div>
          </div>
        </div>
    }
  </>
);

const handlevalue = (identifier: any, value: any, valuesType: any) => {
  let returnValue: any;
  if (value === '' || value === undefined || value === null) {
    return ''
  }
  returnValue = Number(value);
  if (valuesType === 'index') {
    if (returnValue >= 0) {
      return <span style={{ color: getFontColorAsPerValue(returnValue), fontWeight: '600' }}>{returnValue?.toFixed(2)}</span>
    }
    else if (returnValue < 0) {
      return <span style={{ color: getFontColorAsPerValue(returnValue), fontWeight: '600' }}>{returnValue?.toFixed(2)}</span>
    }
    else if (returnValue === '') {
      return <span></span>
    }
    else {
      return <span style={{ color: getFontColorAsPerValue(returnValue), fontWeight: '600' }}>{returnValue?.toFixed(2)}</span>
    }
  } else {
    return returnValue?.toFixed(2)
  }
}


const handleReleaseNote = () => {
  let release_show_count: any = 0
  try {
    let count: any = window.localStorage.getItem("release_show_count");
    release_show_count = parseInt(count)
  }
  catch {
    window.localStorage.setItem("release_show_count", "0")
  }
  if (window.localStorage.getItem("version") !== APP_VERSION) {
    window.localStorage.setItem("version", APP_VERSION)
    window.localStorage.setItem("release_show_count", "0")
  }
  else {
    if (release_show_count < 3) {
      setReleaseShowCount(releaseShowCount + 1)
      fetchReleaseDetails(APP_VERSION)
      window.localStorage.setItem("release_show_count", String(release_show_count + 1))
    }
  }
}

const fetchReleaseDetails = async (version: any) => {
  await getReleaseNote(version).then((res: any) => {
    if ((res !== undefined) || (res !== null)) {
      setReleaseDetails(res)
    }
  })
}

const handleReleaseCheck = (event: any) => {
  setReleaseNoteChkBox(!releaseNoteChkBox)
  window.localStorage.setItem("release_show_count", "3")
}

const handleClose = () => {
  localStorage.setItem('release_show_count', modalshow + 1)
  releaseNoteChkBox && setReleaseNoteShow(false);
}

const getFontColorAsPerValue = (value: any) => {
  if (theme === 'light') {
    return value >= 0 ? '#338f33' : "orangered";
  }
  else if (theme === 'dark') {
    if (value === null) return "";
    return value >= 0 ? "lightgreen" : "orangered";
  }
  else if (theme === 'b&w') {
    return value >= 0 ? 'lightgreen' : "orangered";
  }
}

const getTradesUsingTabChanging = useCallback(
  debounce(() => {
    getTrades({
      variables: {
        username: getUserMail(),
        tab: activeTab,
        tradeCategory:adviceType === "OPT LONG" ? "OPT_LONG" :adviceType,
        startIndex:activeTab === "Live" ? 0 :first
      }
    });
  },500),
    [activeTab],
  )


  useEffect(() => {
    const currentDate:any = new Date();
    if (selectedDate === moment(currentDate).format("YYYY-MM-DD")) {

      getTrades({
        variables: {
          username: getUserMail(),
          tab: activeTab,
          tradeCategory:adviceType === "OPT LONG" ? "OPT_LONG" :adviceType,
          startIndex:activeTab === "Live" ? 0 :first
        },
  
      })


      getTotalTrades({
        variables:{
          username: getUserMail()
        }
      })
    }


 
    let getObj: any = localStorage.getItem('order');
    const order: any = JSON.parse(getObj);
    if (order) {
      setVisibleColumns(order);
    }
 
  }, [adviceType]);


  useEffect(() => {
    const today = new Date();
    if (liveBtnRef.current && executedBtnRef.current) {
      const activeBtn:any = activeTab === "Live" ? liveBtnRef.current : executedBtnRef.current;
      setActiveStyle({
        width: `${activeBtn.offsetWidth}px`,
        transform: `translateX(${activeBtn.offsetLeft}px)`});

      if(selectedDate === moment(today).format("YYYY-MM-DD")){
        getTradesUsingTabChanging();
       
        getTradeCount({
          variables: {
            userName:getUserMail()
          }
        })
      }
    }

  }, [activeTab]);


  useEffect(()=>{

    //live page
    if(selectedDate === moment(new Date()).format('YYYY-MM-DD')){

      if(activeTab === 'Live'){
        if(liveData?.length > 0){
          setSelectedTrade(liveData[0])
        }
        else{
          setSelectedTrade(null);
        }
     
      }
    }
    //back dated
    else{
      if(activeTab === 'Live'){
          if(adviceType === "FNO"){
            const fno_arr:any[] = liveOverAllData?.filter((item:any)=>(item?.trade_category === "FNO" && item?.s_reason === "Open"));
           
            if(fno_arr?.length > 0){
             
              setBackdatedFilteredFNOData(fno_arr);
              const params = backdatedParamsSet1(fno_arr[0]);
              setSelectedTradeId(params[0]?.unique_id ?? ' ');
 
              setBackdatedDesc_Ts(params);
              setM2mGraphArray(calculate_m2m_graph(fno_arr[0]?.m2m_array,' '));

            
            }
            else{
              setBackdatedFilteredFNOData([]);
              setSelectedTradeId('');
              setBackdatedDesc_Ts([]);
              setM2mGraphArray([]);
              setSelectedPreviewTableData([]);

            }
          }
          else if(adviceType === "LFT"){
            const lft_arr:any[] = liveOverAllData?.filter((item:any)=>(item?.trade_category === "LFT" && item?.s_reason === "Open"));
           
            if(lft_arr?.length > 0){

              setBackdatedFilteredLFTData(lft_arr);
              const params = backdatedParamsSet1(lft_arr[0]);
              setSelectedTradeId(params[0]?.unique_id ?? ' ');
 
              setBackdatedDesc_Ts(params);
              setM2mGraphArray(calculate_m2m_graph(lft_arr[0]?.m2m_array,' '));
              setSelectedPreviewTableData(lft_arr);
            
            }
            else{
              setBackdatedFilteredLFTData([]);
              setSelectedTradeId('');
              setBackdatedDesc_Ts([]);
              setM2mGraphArray([]);
              setSelectedPreviewTableData([]);

            }
          }
          else if(adviceType === "OPT LONG"){ //bug fixed
            const optLong_arr:any[] = liveOverAllData?.filter((item:any)=>(item?.trade_category === "LFT" && item?.s_reason === "Open"));
           
            if(optLong_arr?.length > 0){

              setBackdatedFilteredOptLongData(optLong_arr);
              const params = backdatedParamsSet1(optLong_arr[0]);
              setSelectedTradeId(params[0]?.unique_id ?? ' ');
 
              setBackdatedDesc_Ts(params);
              setM2mGraphArray(calculate_m2m_graph(optLong_arr[0]?.m2m_array,' '));
              setSelectedPreviewTableData(optLong_arr);
            
            }
            else{
              setBackdatedFilteredOptLongData([]);
              setSelectedTradeId('');
              setBackdatedDesc_Ts([]);
              setM2mGraphArray([]);
              setSelectedPreviewTableData([]);
            }
          }
          else if(adviceType === "EQ"){
            const eq_arr:any[] = liveOverAllData?.filter((item:any)=>(item?.trade_category === "EQ" && item?.s_reason === "Open"));
           
            if(eq_arr?.length > 0){
              setBackdatedFilteredEQData(eq_arr);
              const params = backdatedParamsSet1(eq_arr[0]);
              setSelectedTradeId(params[0]?.unique_id ?? ' ');
 
              setBackdatedDesc_Ts(params);
              setM2mGraphArray(calculate_m2m_graph(eq_arr[0]?.m2m_array,' '));
              setSelectedPreviewTableData(eq_arr); 
            }
            else{
              setBackdatedFilteredEQData([]);
              setSelectedTradeId('');
              setBackdatedDesc_Ts([]);
              setM2mGraphArray([]);
              setSelectedPreviewTableData([]);
            }
          }
          else if(adviceType === "EqBANK"){
          const eq_arr:any[] = liveOverAllData?.filter((item:any)=>(item?.trade_category === "EqBANK" && item?.s_reason === "Open"));
          if(eq_arr?.length > 0){
            setBackdatedFilteredEQData(eq_arr);
            const params = backdatedParamsSet1(eq_arr[0]);
            setSelectedTradeId(params[0]?.unique_id ?? ' ');

            setBackdatedDesc_Ts(params);
            setM2mGraphArray(calculate_m2m_graph(eq_arr[0]?.m2m_array,' '));
            setSelectedPreviewTableData(eq_arr);
          
          }
          else{
            setBackdatedFilteredEQData([]);
            setSelectedTradeId('');
            setBackdatedDesc_Ts([]);
            setM2mGraphArray([]);
            setSelectedPreviewTableData([]);
          }
        }
          else {
            const eqNXT50_arr:any[] = liveOverAllData?.filter((item:any)=>(item?.trade_category === "EqN50plus" && item?.s_reason === "Open"));
           
            if(eqNXT50_arr?.length > 0){

              setBackdatedFilteredEqN50Data(eqNXT50_arr);
              const params = backdatedParamsSet1(eqNXT50_arr[0]);
              setSelectedTradeId(params[0]?.unique_id ?? ' ');
 
              setBackdatedDesc_Ts(params);
              setM2mGraphArray(calculate_m2m_graph(eqNXT50_arr[0]?.m2m_array,' '));
              setSelectedPreviewTableData([eqNXT50_arr]);
            
            }
            else{
              setBackdatedFilteredEQData([]);
              setSelectedTradeId('');
              setBackdatedDesc_Ts([]);
              setM2mGraphArray([]);
              setSelectedPreviewTableData([]);

            }
          }
      }
      else{
        if(adviceType === "FNO"){
          const fno_arr:any[] = liveOverAllData?.filter((item:any)=>(item?.trade_category === "FNO" && item?.s_reason !== "Open"));
         
          if(fno_arr?.length > 0){

            setBackdatedFilteredFNOData(fno_arr);
            const params = backdatedParamsSet1(fno_arr[0]);
            setSelectedTradeId(params[0]?.unique_id ?? ' ');

            setBackdatedDesc_Ts(params);
            setM2mGraphArray(calculate_m2m_graph(fno_arr[0]?.m2m_array,' '));
            setSelectedPreviewTableData(fno_arr);
          
          }
          else{
            setBackdatedFilteredFNOData([]);
            setSelectedTradeId('');
            setBackdatedDesc_Ts([]);
            getM2MArray({
              variables:{
                uniqueId: "None"
              }
             
            })
            setSelectedPreviewTableData([]);

          }
        }
        else if(adviceType === "LFT"){
          const lft_arr:any[] = liveOverAllData?.filter((item:any)=>(item?.trade_category === "LFT" && item?.s_reason !== "Open"));
         
          if(lft_arr?.length > 0){

            setBackdatedFilteredLFTData(lft_arr);
            const params = backdatedParamsSet1(lft_arr[0]);
            setSelectedTradeId(params[0]?.unique_id ?? ' ');

            setBackdatedDesc_Ts(params);
            setM2mGraphArray(calculate_m2m_graph(lft_arr[0]?.m2m_array,' '));
            setSelectedPreviewTableData(lft_arr);
          
          }
          else{
            setBackdatedFilteredLFTData([]);
            setSelectedTradeId('');
            setBackdatedDesc_Ts([]);
            getM2MArray({
              variables:{
                uniqueId: "None"
              }
             
            })
            setSelectedPreviewTableData([]);

          }
        }
        else if(adviceType === "OPT LONG"){
          const optLong_arr:any[] = liveOverAllData?.filter((item:any)=>(item?.trade_category === "OPT LONG" && item?.s_reason !== "Open"));          
          if(optLong_arr?.length > 0){

            setBackdatedFilteredOptLongData(optLong_arr);
            const params = backdatedParamsSet1(optLong_arr[0]);
            setSelectedTradeId(params[0]?.unique_id ?? ' ');

            setBackdatedDesc_Ts(params);
            setM2mGraphArray(calculate_m2m_graph(optLong_arr[0]?.m2m_array,' '));
            setSelectedPreviewTableData(optLong_arr);
          
          }
          else{
            setBackdatedFilteredOptLongData([]);
            setSelectedTradeId('');
            setBackdatedDesc_Ts([]);
            getM2MArray({
              variables:{
                uniqueId: "None"
              }
             
            })
            setSelectedPreviewTableData([]);

          }
        }
        else if(adviceType === "EQ"){
          const eq_arr:any[] = liveOverAllData?.filter((item:any)=>(item?.trade_category === "EQ" && item?.s_reason !== "Open"));
         
          if(eq_arr?.length > 0){

            setBackdatedFilteredEQData(eq_arr);
            const params = backdatedParamsSet1(eq_arr[0]);
            setSelectedTradeId(params[0]?.unique_id ?? ' ');

            setBackdatedDesc_Ts(params);
            setM2mGraphArray(calculate_m2m_graph(eq_arr[0]?.m2m_array,' '));
            setSelectedPreviewTableData(eq_arr);
          
          }
          else{
            setBackdatedFilteredEQData([]);
            setSelectedTradeId('');
            setBackdatedDesc_Ts([]);
            getM2MArray({
              variables:{
                uniqueId: "None"
              }
             
            })
            setSelectedPreviewTableData([]);

          }
        }
        else if(adviceType === "EqBANK"){
          const eq_arr:any[] = liveOverAllData?.filter((item:any)=>(item?.trade_category === "EqBANK" && item?.s_reason !== "Open"));
         
          if(eq_arr?.length > 0){

            setBackdatedFilteredEQData(eq_arr);
            const params = backdatedParamsSet1(eq_arr[0]);
            setSelectedTradeId(params[0]?.unique_id ?? ' ');

            setBackdatedDesc_Ts(params);
            setM2mGraphArray(calculate_m2m_graph(eq_arr[0]?.m2m_array,' '));
            setSelectedPreviewTableData(eq_arr);
          
          }
          else{
            setBackdatedFilteredEQData([]);
            setSelectedTradeId('');
            setBackdatedDesc_Ts([]);
            getM2MArray({
              variables:{
                uniqueId: "None"
              }
             
            })
            setSelectedPreviewTableData([]);

          }
        }
        else {
          const eqNXT50_arr:any[] = liveOverAllData?.filter((item:any)=>(item?.trade_category === "EqN50plus" && item?.s_reason !== "Open"));
         
          if(eqNXT50_arr?.length > 0){

            setBackdatedFilteredEqN50Data(eqNXT50_arr);
            const params = backdatedParamsSet1(eqNXT50_arr[0]);
            setSelectedTradeId(params[0]?.unique_id ?? ' ');

            setBackdatedDesc_Ts(params);
            setM2mGraphArray(calculate_m2m_graph(eqNXT50_arr[0]?.m2m_array,' '));
          
            setSelectedPreviewTableData(eqNXT50_arr);
          }
          else{
            setBackdatedFilteredEQData([]);
            setSelectedTradeId('');
            setBackdatedDesc_Ts([]);
            getM2MArray({
              variables:{
                uniqueId: "None"
              }
             
            })
            setSelectedPreviewTableData([]);

          }
        }
      }
    }
    return()=>{
      setFirst(0);
      // getTradeCount({ //bug
      //   variables: {
      //     userName:getUserMail()
      //   }
      // })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[activeTab, adviceType, liveOverAllData])

  useEffect(() => {
    fetchWordCloudImage()
  }, [wordCloudDataSocket])

  useEffect(() => {
    setSelectedTrade(null)
  },[selectedDate, adviceType])

  useEffect(() => {
    let todayDate: any = moment(new Date()).format("YYYY-MM-DD");
    if (selectedDate === todayDate) {
      const todayReturnCalculator: any = returnCalculator(allTradesData, selectedModels, null, selectedDate)
      dispatch(setReturnCalculator(todayReturnCalculator))
    }
    else {
      const todayReturnCalculator: any = returnCalculator(liveOverAllData, selectedModels, null, selectedDate)
      dispatch(setReturnCalculator(todayReturnCalculator))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedModels])

  const deleted_trade = (data: any) => {
    
    //deletion
    setLiveData((prev: any) => {
      return prev.filter(
        (item: any) => item.unique_id !== data.row?.unique_id
      );
    });
    setAllTradesData((prev: any) => {
      return prev.filter(
        (item: any) => item.unique_id !== data.row?.unique_id
      );
    });



    if(data?.row?.trade_category === 'FNO'){
      setFilteredFNOData((prev: any) => {
        return prev.filter(
          (item: any) => item.unique_id !== data.row?.unique_id
        );
      });
    }

    if(data?.row?.trade_category === 'LFT'){
      setFilteredLFTData((prev: any) => {
        return prev.filter(
          (item: any) => item.unique_id !== data.row?.unique_id
        );
      });
    }

    if(data?.row?.trade_category === 'EQ'){
      setFilteredEQData((prev: any) => {
        return prev.filter(
          (item: any) => item.unique_id !== data.row?.unique_id
        );
      });
    }
    if(data?.row?.trade_category === 'EqBANK'){
      setFilteredEQBankData((prev: any) => {
        return prev.filter(
          (item: any) => item.unique_id !== data.row?.unique_id
        );
      });
    }
    if(data?.row?.trade_category === 'OPT LONG'){
      setFilteredOptLongData((prev: any) => {
        return prev.filter(
          (item: any) => item.unique_id !== data.row?.unique_id
        );
      });
    }

    if(data?.row?.trade_category === 'EqN50plus'){
      setFilteredEqN50Data((prev: any) => {
        return prev.filter(
          (item: any) => item.unique_id !== data.row?.unique_id
        );
      });
    }


  
  };
  
  


  useEffect(()=>{
    const today = new Date();

    (async function(){
      if (Object.keys(startandEndDate).length === 0 && adviceType==='EQ') {
        let contractDateResponse: any = await getStartEndDateSF(12, "equityMultiday", "equityMultiday")
        setStartAndEndDate(contractDateResponse)
      }
      else if (Object.keys(startandEndDate).length === 0 && adviceType==='EqBANK') {
        let contractDateResponse: any = await getStartEndDateSF(12, "equityN50BANK", "equityN50BANK")
        setStartAndEndDate(contractDateResponse)
      }
    })()
    if(selectedDate === moment(today).format("YYYY-MM-DD")){

      getTrades({
        variables: {
          username: getUserMail(),
          tab: activeTab,
          tradeCategory:adviceType === "OPT LONG" ? "OPT_LONG" :adviceType,
          startIndex:activeTab === "Live" ? 0 :first
        },
  
      })
    }
  },[adviceType])



  useEffect(() => {
    const fetchData = async () => {
      let strengthReason:string  = "";
      
      try {
        if (adviceType === "EQ" && (desc_ts.length > 0 || backdatedDesc_ts.length > 0)){
          const today:boolean = selectedDate === moment(new Date()).format("YYYY-MM-DD");
          const date:string   = today? desc_ts[0]?.dt_date || "": backdatedDesc_ts[0]?.open_date || "";
          const symbol:string = today? desc_ts[0]?.s_symbol || "": backdatedDesc_ts[0]?.s_symbol || "";
          const time:string   = (today? desc_ts[0]?.entryPoint || "": backdatedDesc_ts[0]?.dt_open_time || "");

          //Fetch Trade Reason
          const tradeReasonRes:any = await getTradeReason(date, symbol, time);

          //Fetch Stock Strength
          if (Object.keys(startandEndDate).length > 0 && Object.keys(tradeReasonRes).length > 0){            
            try {
                strengthReason =  await findStrength(today);
                // Add strength to tradeReason
                setTradeReason({...tradeReasonRes,strength: strengthReason});
              // }//else setTradeReason(tradeReasonRes);
            } catch(error) {
              setStockStrength("");
            }
          }else if(Object.keys(startandEndDate).length > 0){
            setStockStrength(await findStrength(today));
            if(Object.keys(tradeReasonRes).length === 0){
              setTradeReason({});
            }
          }
         
        }
        else if (adviceType === "EqBANK" && (desc_ts.length > 0 || backdatedDesc_ts.length > 0)){
          const today:boolean = selectedDate === moment(new Date()).format("YYYY-MM-DD");
          const date:string   = today? desc_ts[0]?.dt_date || "": backdatedDesc_ts[0]?.open_date || "";
          const symbol:string = today? desc_ts[0]?.s_symbol || "": backdatedDesc_ts[0]?.s_symbol || "";
          const time:string   = (today? desc_ts[0]?.entryPoint || "": backdatedDesc_ts[0]?.dt_open_time || "");

          //Fetch Trade Reason
          const tradeReasonRes:any = await getTradeReason(date, symbol, time);

          //Fetch Stock Strength
          if (Object.keys(startandEndDate).length > 0 && Object.keys(tradeReasonRes).length > 0){            
            try {
                strengthReason =  await findStrengthBank(today);
                // Add strength to tradeReason
                setTradeReason({...tradeReasonRes,strength: strengthReason});
              // }//else setTradeReason(tradeReasonRes);
            } catch(error) {
              setStockStrength("");
            }
          }else if(Object.keys(startandEndDate).length > 0){
            setStockStrength(await findStrength(today));
            if(Object.keys(tradeReasonRes).length === 0){
              setTradeReason({});
            }
          }
         
        }
      } catch (error) {
        console.error("Error in fetching data:", error);
        setTradeReason({});
      }
    };
    fetchData();
  }, [desc_ts, backdatedDesc_ts]);

  useEffect ( () => {
    getColOrder()
    setCurrDateSelected(!currDateSelected)
  }, [localStorage.getItem('notificationEnabled'), adviceType])


  useEffect(()=> {
    if(calenderValue && selectedDate == moment(new Date()).format("YYYY-MM-DD")){
      window.location.reload()
    }

    setBackdatedFilteredFNOData([])
    setBackdatedFilteredLFTData([])
    setBackdatedFilteredEQData([])
    setBackdatedFilteredOptLongData([])
    setOrderedCol([])
    setOrderedColEq([])
    // setOrderedColEqN50([])
    setLiveOverAllData([])
    backDatedTradeResponse()
    setAdviceType('FNO')
    dispatch(setSelectedDateStore(selectedDate))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate])


  useEffect(()=>{
    let option_col:any = []
    let equity_col:any = []
    if(selectedDate == moment(new Date()).format("YYYY-MM-DD")){

      orderedCol?.map((item:any,index:any)=> {
        columns.filter((i:any)=> {
          if(i.header == item.header){
            option_col.push({field: i.field, header: i.header})
          }})
      })
      orderedColEq?.map((item:any,index:any)=> {
        equity_columns.filter((i:any)=> {
          if(i.header == item.header){
            equity_col.push({field: i.field, header: i.header})
          }})
        })

    }
    if(selectedDate < moment(new Date()).format("YYYY-MM-DD")){
      getColOrder()
      orderedCol?.map((item:any,index:any)=> {
        backdatedVisibleColumns.filter((i:any)=> {
          if(i.header == item.header){
            option_col.push({field: i.field, header: i.header})
          }})
      })
      orderedColEq?.map((item:any,index:any)=> {
        backdatedeqVisibleColumnsState.filter((i:any)=> {
          if(i.header == item.header){
            equity_col.push({field: i.field, header: i.header})
          }})
        })

       
    }
    if(option_col.length > 0 && equity_col.length > 0 ){
      saveColOrder({"opt": option_col, "equity": equity_col}, '')
      setOrderedCol(option_col)
      setOrderedColEq(equity_col)
      // getColOrder()
    }
  }, [selectedDate, currDateSelected])

  useSocketEvent("rightSidebarModalReturn",(data: any) => {
    // alert("lol")
    
    let cookiesCodesArr: any = Cookies.get('codesArray') || []
    // console.log("#############3333",data?.s_code, JSON?.parse(cookiesCodesArr)?.includes(accessChecking(data)));
    if (JSON?.parse(cookiesCodesArr)?.includes(accessChecking(data))) {
      
      let todayDate: any = moment(new Date()).format("YYYY-MM-DD")
      if(selectedDate === todayDate){

        returnCalculator(allTradesData, selectedModels, [], selectedDate); ///////////////turn it on.....!!
        secondDataModelReturn(data) //real time return sidebar updater
        let successRatioResponse: any = initSuccessRatio(allTradesData);
        setSuccessRatio((prev: any) => { return successRatioResponse });
        dispatch(setSuccessRatioData(successRatioResponse))
      }
    }
  }
  ,[[allTradesData, desc_ts, adviceType]]);
  
  useSocketEvent('new_row',
  (newRow: any)=>{
    // console.log("new rtow listene in livedatable.tsx",newRow,"=>>>",liveData)
        // alert("log")      
        const current_date: any = new Date();
        if (newRow?.dt_date !== moment(current_date).format("YYYY-MM-DD")) {
          return
        }
        let updatedNewTrade:any = {};
        
        let cookiesCodesArr: any = Cookies.get('codesArray') || []

        const isPassed:boolean = isPrivilegedAndCurrebtDate(cookiesCodesArr, newRow, selectedDate, current_date);
        
        // console.log("Live data Check ",JSON?.parse(cookiesCodesArr)?.includes(accessChecking(newRow)))
        if ((isPassed) && (activeTab === "Live")) {


          if(newRow?.trade_category === adviceType){

            updatedNewTrade ={
             ...newRow,
             dt_date:moment(newRow?.dt_date).format("DD MMM YYYY"),
           }
  
           let tempdata:any[] = structuredClone(liveData);
           tempdata?.unshift(updatedNewTrade)
  
           // console.log("Live data size",liveData?.length);
           // console.log("Live Temp data size",temdata?.length);
  
          //  setLiveData(tempdata);
          setLiveData((prev) => {
            const alreadyExists = prev.some(item => item?.unique_id === updatedNewTrade?.unique_id);
            if (!alreadyExists) {
              // Find the selected trade from the incoming data
              const updated = [updatedNewTrade, ...prev];
              const trade = updated.find(item => item?.unique_id === selectedTradeId);
              setSelectedTrade(trade);
        
              return updated;
            }
            return prev;
          });
         
           //real time data updation
           if(desc_ts?.length === 0){

          // this block update the parameters section in real time based on the selected advice type
           let newTslObj:TslObject = {time: Object.keys(newRow?.j_target_stoploss)[0]};

             const mappedItem: any = {
               model_type: newRow?.model_type ?? ' ', //new added
               s_symbol: newRow?.s_symbol, //new added
               s_code: newRow.s_code === null ? " " : newRow.s_code,
               s_option_type: newRow?.s_option_type === undefined || null ? ' ' : newRow?.s_option_type,
               n_strike_price: newRow?.n_strike_price === undefined || null ? ' ' : newRow?.n_strike_price,
               dt_exit_time: newRow.s_status === 'Open' ? ' ' : newRow?.dt_exit_time,
               dt_expiry_date: newRow?.dt_expiry_date === undefined || null ? ' ' : moment(newRow?.dt_expiry_date).format('YYYY-MM-DD'),
               s_status: newRow?.s_status,
               dt_date:moment(newRow?.dt_date).format("YYYY-MM-DD"),
               tsl_arr:[]
             };
    
    
     
             if ((newRow?.j_target_stoploss[String(Object.keys(newRow?.j_target_stoploss))]?.Target !== undefined) && (newRow?.j_target_stoploss[String(Object.keys(newRow?.j_target_stoploss))]?.Stoploss !== undefined)) {
               
               mappedItem.tsl_arr?.push(
     
                 {...newTslObj,
                   target :newRow?.j_target_stoploss[String(Object.keys(newRow?.j_target_stoploss))]?.Target,
                   stoploss : newRow?.j_target_stoploss[String(Object.keys(newRow?.j_target_stoploss))]?.Stoploss
                 }
                 )
               setDesc_Ts([mappedItem]);
     
               // return mappedItem;
     
             }
             if (newRow?.j_target_stoploss[String(Object.keys(newRow?.j_target_stoploss))]?.Target !== undefined) {
               mappedItem.tsl_arr?.push(
     
                 {...newTslObj,
                   target :newRow?.j_target_stoploss[String(Object.keys(newRow?.j_target_stoploss))]?.Target
                 }
                )
                 setDesc_Ts([mappedItem]);
               // return mappedItem;
     
     
             }
             if (newRow?.j_target_stoploss[String(Object.keys(newRow?.j_target_stoploss))]?.Stoploss !== undefined) {
               mappedItem.tsl_arr?.push(
     
                 {...newTslObj,
                   stoploss :newRow?.j_target_stoploss[String(Object.keys(newRow?.j_target_stoploss))]?.Stoploss
                 }
                )
                setDesc_Ts([mappedItem]);
               // return mappedItem;
     
     
             }
          }

        
          }
          


          
          if (selectedDate === moment(current_date).format("YYYY-MM-DD")) {
            updateObj(newRow, successRatio, [updatedNewTrade,...allTradesData]);
            const getInitSuccessRatio = initSuccessRatio([updatedNewTrade,...allTradesData])
            setSuccessRatio(getInitSuccessRatio)
            dispatch(setSuccessRatioData(getInitSuccessRatio))
            addNewInRightSidebar(newRow)
            returnCalculator([updatedNewTrade,...allTradesData], selectedModels, null, selectedDate)
          }

          // console.log("Live New row end")
  
          
        }


        //real time table header count increase as new new trade enters
        if((isPassed) && (selectedDate === moment(current_date).format("YYYY-MM-DD"))){

          if(newRow?.trade_category === 'FNO'){
            setTradeCount((prev:TradesCount)=>{return {...prev, FNO:prev.FNO +1}})
          }

          if(newRow?.trade_category === 'LFT'){
            setTradeCount((prev:TradesCount)=>{return {...prev, LFT:prev.LFT +1}})
          }

          if(newRow?.trade_category === 'OPT LONG'){
            setTradeCount((prev:TradesCount)=>{return {...prev, OPT_LONG:prev.OPT_LONG +1}})
          }

          if(newRow?.trade_category === 'EQ'){
            setTradeCount((prev:TradesCount)=>{return {...prev, EQ:prev.EQ +1}})
          }
          if(newRow?.trade_category === 'EqBANK'){
            setTradeCount((prev:TradesCount)=>{return {...prev, EqBANK:prev.EqBANK +1}})
          }

          if(newRow?.trade_category === 'EqN50plus'){
            setTradeCount((prev:TradesCount)=>{return {...prev, EqN50plus:prev.EqN50plus +1}})

          }

          //allTrades
          setAllTradesData((prev:any)=>[updatedNewTrade,...prev]);

        } //moved
    
  },[[liveData,desc_ts, adviceType]])

  useSocketEvent("data_change", onDataChange,[[liveData, desc_ts, adviceType]]);
  
  useSocketEvent("live_ts", liveTsChanges,[[liveData, desc_ts, adviceType]]);

  useSocketEvent("m2mgeneration:completed", m2mGenerator,[[liveData, desc_ts, adviceType]]);

 






  useSocketEvent("delete_row", deleted_trade,[[liveData, desc_ts, adviceType]]);

  useSocketEvent("wordCloudInserted", (newData:any) => {setWordCloudDataSocket(newData)},[[liveData, desc_ts, adviceType]]);

  useTabInactivityReload(900000); //15 min (900000)



  return (
    <>
      <div className="mainContainer">
        <Disclaimer />
        <div className="cont_filter">
          <div className="returnContainer">
            <ReturnContainer selectedDate={selectedDate} />
          </div>
          <div
            className="calender_div"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
            }}
          >
            {/* word cloud */}
            <div
              className="wordCloud-img-live"
              title={`Last updated: ${String(
                moment(new Date(wordCloudImgUpdateTime)).format(
                  "DD MMM YYYY h:mm:ss"
                )
              )}`}
            >
              <img
                src={`data:image/png;base64, ${wordCloudImage}`}
                alt="word-cloud"
                className="wordCloudImg"
              />
            </div>
            {/* Calendar Section */}
            <div style={{}}>
              <button
                onClick={() => {
                  setCalenderIsVisisble(!calenderisvisisble);
                  setCalenderValue(true);
                }}
              >
                <img src="/icons/icons-view-schedule.png" alt="schedule" />
              </button>
              <div>
                {calenderisvisisble && (
                  <Calender
                    calenderisvisisble={calenderisvisisble.toString()}
                    setCalenderIsVisisble={setCalenderIsVisisble}
                    setSelectedDate={setSelectedDate}
                    selectedDate={selectedDate}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <ToastContainer
          onClick={() => {
            toast.dismiss();
          }}
        />
        <PreviewTable
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          tableData={selectedPreviewTableData}
          selectedDate={moment(selectedDate).format("DD MMM YYYY")}
          onDownload={onDownload}
        />
        {selectedDate === moment(new Date()).format("YYYY-MM-DD") ? (
          <div className="mainCard">
            <div className="table">
              <span className="text">
                Live Advice <span className="innerText">(Today)</span>
              </span>
              <div className="table_card">
                {loader ? (
                  <ThreeDots
                    visible={true}
                    height="60"
                    width="60"
                    color="#8eabc5"
                    radius="9"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                  />
                ) : (
                  <DataTable
                    value={liveData}
                    header={header}
                    className="fno"
                    id="selected_row"
                    scrollable
                    onSort={handleSorting}
                    selectionMode="single"
                    selection={selectedTrade || liveData[0]}
                    onSelectionChange={(e: any) => {
                      e?.value && setSelectedTrade(e.value);
                    }}
                    dataKey="unique_id"
                    onRowSelect={onRowSelect}
                    onColReorder={(e: any) =>
                      onColumnDrag(e.columns, e.dropIndex)
                    }
                    columnResizeMode="expand"
                    resizableColumns
                    reorderableRows
                    totalRecords={totalTradeCount(adviceType)}
                    lazy
                    paginator={
                      activeTab === "Executed" &&
                      totalTradeCount(adviceType) > 0
                    }
                    rows={rows}
                    loading={tradeLoading}
                    first={first}
                    onPage={handlePagination}
                    reorderableColumns
                    onRowReorder={(e) => setLiveData(e.value)}
                    removableSort
                    tableStyle={{ minWidth: "50rem" }}
                    rowClassName={activeTrade}
                  >
                    <Column
                      frozen
                      className="reorder"
                      rowReorder
                      style={{
                        width: "3rem",
                        background: "#dae6f1",
                        zIndex: "1",
                      }}
                    />

                    {["EQ", "EqN50plus","EqBANK"].includes(adviceType)
                      ? orderedColEq?.map((col: any, index: any) => (
                          <Column
                            field={String(
                              getColumnDiv("field", col, eqvisibleColumns)
                            )}
                            header={col.header}
                            sortable={
                              [
                                "dt_date",
                                "n_transaction",
                                "s_status",
                                "n_exit_price",
                                "s_trade_type",
                                "n_pl_rs",
                                "oneDayPl",
                                "oneDay_return_per",
                                "n_return_after_cost",
                                "dt_close_date",
                                "dt_exit_time",
                              ].includes(col.field)
                                ? false
                                : true
                            }
                            body={(e: any) => (
                              <>
                                {[
                                  "P/L",
                                  "P/L (₹)",
                                  "1D P/L",
                                  "1D Return(%)",
                                  "Return(%)",
                                  "Return After Cost (%)",
                                ].includes(col.header) ? (
                                  <div
                                    style={{
                                      border: "none",
                                      color: getFontColorAsPerValue(
                                        e[
                                          String(
                                            getColumnDiv(
                                              "field",
                                              col,
                                              eqvisibleColumns
                                            )
                                          )
                                        ]
                                      ),
                                    }}
                                    className="hovertextdiv hoverd"
                                    data-hover={
                                      e[col.field] !== undefined
                                        ? Number(e[col.field])?.toFixed(4)
                                        : ""
                                    }
                                  >
                                    {handlevalue(
                                      e.identifier,
                                      e[col.field],
                                      "index"
                                    )}{" "}
                                  </div>
                                ) : (
                                  <div>{e[col.field]} </div>
                                )}
                              </>
                            )}
                          ></Column>
                        ))
                      : orderedCol
                          ?.filter(
                            (col: any, index: any) =>
                              ["1D P/L", "1D Return(%)", "Close Date"].includes(
                                col.header
                              ) == false
                          )
                          .map((col: any) => (
                            <Column
                              field={String(
                                getColumnDiv("field", col, visibleColumns)
                              )}
                              header={col?.header}
                              sortable={
                                [
                                  "dt_date",
                                  "n_transaction",
                                  "s_status",
                                  "n_exit_price",
                                  "s_trade_type",
                                  "n_pl_rs",
                                  "n_return_after_cost",
                                  "dt_exit_time",
                                ].includes(col.field)
                                  ? false
                                  : true
                              }
                              body={(e: any) => (
                                <>
                                  {[
                                    "P/L",
                                    "P/L (₹)",
                                    "Return(%)",
                                    "Return After Cost (%)",
                                  ].includes(col.header) ? (
                                    <div
                                      style={{
                                        border: "none",
                                        color: getFontColorAsPerValue(
                                          e[col.field]
                                        ),
                                      }}
                                      className="hovertextdiv hoverd"
                                      data-hover={
                                        e[col.field] !== undefined
                                          ? Number(e[col.field])?.toFixed(4)
                                          : ""
                                      }
                                    >
                                      {handlevalue(
                                        e.identifier,
                                        e[col.field],
                                        "index"
                                      )}{" "}
                                    </div>
                                  ) : (
                                    <div>{e[col.field]} </div>
                                  )}
                                </>
                              )}
                            ></Column>
                          ))}
                  </DataTable>
                )}
              </div>
            </div>
            {/* Live Parameters div */}
            <div className="params_div">
              <div className="params_content">
                <div className="params_heading">
                  <span className="detals_heading">Details</span>
                  <div className="m2m_graph">
                    {m2mArrayLoading ? (
                      <ThreeDots
                        visible
                        height="60"
                        width="60"
                        color="#8eabc5"
                        radius="9"
                        ariaLabel="three-dots-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                      />
                    ) : (
                      <M2mGraphChart
                        key={selectedTradeId}
                        uniqueId={selectedTradeId}
                        m2marray={m2mGraphArray}
                        page={" "}
                      />
                    )}
                  </div>
                </div>
                {loading ? (
                  <div className="loader_Div">
                    <ThreeDots
                      visible={true}
                      height="30"
                      width="50"
                      color="#8eabc5"
                      radius="9"
                      ariaLabel="three-dots-loading"
                      wrapperStyle={{}}
                      wrapperClass=""
                    />
                  </div>
                ) : (
                  <div className="under_params_heading">
                    {desc_ts?.length > 0 ? (
                      <>
                        <Parameters
                          desc_ts={desc_ts}
                          stockStrength={stockStrength}
                          theme={theme}
                        />
                      </>
                    ) : (
                      "Nothing to show"
                    )}
                  </div>
                )}
              </div>
              {!loading &&
                adviceType === "EQ" &&
                Object.keys(tradeReason).length > 0 && (
                  <PDFDownloadLink
                    document={<ProductNote tradeReason={tradeReason} />}
                    fileName={`${tradeReason["s_symbol"]}_${tradeReason["dt_date"]}.pdf`}
                  >
                    <div className="pdfDownloadStyle">
                      Product note
                      <HiOutlineDownload size={20} />
                    </div>
                  </PDFDownloadLink>
                )}
            </div>
          </div>
        ) : (
          <div className="mainCard">
            <div className="table">
              <span className="text">
                Live Advice{" "}
                <span className="innerText">
                  ({moment(selectedDate).format("DD MMM YYYY")})
                </span>
              </span>
              <div className="table_card">
                {adviceType === "FNO" ? (
                  <DataTable
                    emptyMessage="No trades to show"
                    value={BackdatedFilteredFNOData}
                    header={header}
                    id="selected_row"
                    scrollable
                    selectionMode="single"
                    selection={selectedTrade || BackdatedFilteredFNOData[0]}
                    onSelectionChange={(e: any) => {
                      e?.value && setSelectedTrade(e.value);
                    }}
                    dataKey="uuid"
                    onRowSelect={onRowSelectBackdated}
                    columnResizeMode="expand"
                    resizableColumns
                    reorderableRows
                    virtualScrollerOptions={{ itemSize: 44.5 }}
                    reorderableColumns
                    onColReorder={(e: any) =>
                      onColumnDrag(e.columns, e.dropIndex)
                    }
                    onRowReorder={(e) => setBackdatedFilteredFNOData(e.value)}
                    removableSort
                    tableStyle={{ minWidth: "50rem" }}
                    rowClassName={backDatedActiveTrade}
                  >
                    <Column
                      frozen
                      className="reorder"
                      rowReorder
                      style={{
                        width: "3rem",
                        background: "#dae6f1",
                        zIndex: "1",
                      }}
                    />
                    {orderedCol?.map((col: any, index: any) => (
                      <Column
                        field={String(
                          getColumnDiv("field", col, backdatedVisibleColumns)
                        )}
                        header={col?.header}
                        sortable={
                          [
                            "open_date",
                            "n_open_transaction_price",
                            "s_reason",
                            "exit_price",
                            "trade_type",
                          ].includes(col.field)
                            ? false
                            : true
                        }
                        body={(e: any) => (
                          <>
                            {[
                              "P/L",
                              "P/L (₹)",
                              "1D P/L",
                              "Return(%)",
                              "Return After Cost (%)",
                            ].includes(col.header) ? (
                              <div
                                style={{
                                  border: "none",
                                  color: getFontColorAsPerValue(e[col.field]),
                                }}
                                className="hovertextdiv hoverd"
                                data-hover={
                                  e[col.field] !== undefined
                                    ? Number(e[col.field])?.toFixed(4)
                                    : ""
                                }
                              >
                                {handlevalue(
                                  e.identifier,
                                  e[col.field],
                                  "index"
                                )}{" "}
                              </div>
                            ) : (
                              <div>{e[col.field]} </div>
                            )}
                          </>
                        )}
                      ></Column>
                    ))}
                  </DataTable>
                ) : adviceType === "LFT" ? (
                  <DataTable
                    value={BackdatedFilteredLFTData}
                    header={header}
                    id="selected_row"
                    scrollable
                    selectionMode="single"
                    selection={selectedTrade || BackdatedFilteredLFTData[0]}
                    onSelectionChange={(e: any) => {
                      e?.value && setSelectedTrade(e.value);
                    }}
                    dataKey="uuid"
                    onRowSelect={onRowSelectBackdated}
                    columnResizeMode="expand"
                    resizableColumns
                    reorderableRows
                    reorderableColumns
                    virtualScrollerOptions={{ itemSize: 44.5 }}
                    onColReorder={(e: any) =>
                      onColumnDrag(e.columns, e.dropIndex)
                    }
                    onRowReorder={(e) => setBackdatedFilteredLFTData(e.value)}
                    removableSort
                    tableStyle={{ minWidth: "50rem" }}
                    rowClassName={backDatedActiveTrade}
                  >
                    <Column
                      frozen
                      className="reorder"
                      rowReorder
                      style={{
                        width: "3rem",
                        background: "#dae6f1",
                        zIndex: "1",
                      }}
                    />
                    {orderedCol?.map((col: any, index: any) => (
                      <Column
                        field={String(
                          getColumnDiv("field", col, backdatedVisibleColumns)
                        )}
                        header={col.header}
                        sortable={
                          [
                            "open_date",
                            "n_open_transaction_price",
                            "s_reason",
                            "exit_price",
                            "trade_type",
                          ].includes(col.field)
                            ? false
                            : true
                        }
                        body={(e: any) => (
                          <>
                            {[
                              "P/L",
                              "P/L (₹)",
                              "1D P/L",
                              "Return(%)",
                              "Return After Cost (%)",
                              "P/L (Exclusive of Dividend)",
                            ].includes(col.header) ? (
                              <div
                                style={{
                                  border: "none",
                                  color: getFontColorAsPerValue(e[col.field]),
                                }}
                                className="hovertextdiv hoverd"
                                data-hover={
                                  e[col.field] !== undefined
                                    ? Number(e[col.field])?.toFixed(4)
                                    : ""
                                }
                              >
                                {handlevalue(
                                  e.identifier,
                                  e[col.field],
                                  "index"
                                )}{" "}
                              </div>
                            ) : (
                              <div>{e[col.field]} </div>
                            )}
                          </>
                        )}
                      ></Column>
                    ))}
                  </DataTable>
                ) : adviceType === "OPT LONG" ? (
                  <DataTable
                    value={BackdatedFilteredOptLongData}
                    header={header}
                    id="selected_row"
                    className="eq"
                    scrollable
                    selectionMode="single"
                    selection={selectedTrade || BackdatedFilteredOptLongData[0]}
                    onSelectionChange={(e: any) => {
                      e?.value && setSelectedTrade(e.value);
                    }}
                    dataKey="uuid"
                    onRowSelect={onRowSelectBackdated}
                    columnResizeMode="expand"
                    resizableColumns
                    reorderableRows
                    reorderableColumns
                    virtualScrollerOptions={{ itemSize: 44.5 }}
                    onColReorder={(e: any) =>
                      onColumnDrag(e.columns, e.dropIndex)
                    }
                    onRowReorder={(e) =>
                      setBackdatedFilteredOptLongData(e.value)
                    }
                    removableSort
                    tableStyle={{ minWidth: "50rem" }}
                    rowClassName={backDatedActiveTrade}
                  >
                    <Column
                      frozen
                      className="reorder"
                      rowReorder
                      style={{
                        width: "3rem",
                        background: "#dae6f1",
                        zIndex: "1",
                      }}
                    />
                    {orderedCol?.map((col: any, index: any) => (
                      <Column
                        field={String(
                          getColumnDiv(
                            "field",
                            col,
                            backdatedOptLongvisibleColumns
                          )
                        )}
                        header={col.header}
                        sortable={
                          [
                            "open_date",
                            "n_hedge_ratio",
                            "n_open_transaction_price",
                            "exit_price",
                          ].includes(col.field)
                            ? false
                            : true
                        }
                        body={(e: any) => (
                          <>
                            {[
                              "P/L",
                              "P/L (₹)",
                              "1D P/L",
                              "1D Return(%)",
                              "Return(%)",
                              "Return After Cost (%)",
                              "P/L (Exclusive of Dividend)",
                            ].includes(col.header) ? (
                              <div
                                style={{
                                  border: "none",
                                  color: getFontColorAsPerValue(e[col.field]),
                                }}
                                className="hovertextdiv hoverd"
                                data-hover={
                                  e[col.field] !== undefined
                                    ? Number(e[col.field])?.toFixed(4)
                                    : ""
                                }
                              >
                                {handlevalue(
                                  e.identifier,
                                  e[col.field],
                                  "index"
                                )}{" "}
                              </div>
                            ) : (
                              <div>{e[col.field]} </div>
                            )}
                          </>
                        )}
                      ></Column>
                    ))}
                  </DataTable>
                ) : adviceType === "EQ" ? (
                  <DataTable
                    value={BackdatedFilteredEQData}
                    header={header}
                    id="selected_row"
                    scrollable
                    selectionMode="single"
                    selection={selectedTrade || BackdatedFilteredEQData[0]}
                    onSelectionChange={(e: any) => {
                      e?.value && setSelectedTrade(e.value);
                    }}
                    dataKey="uuid"
                    onRowSelect={onRowSelectBackdated}
                    columnResizeMode="expand"
                    resizableColumns
                    reorderableRows
                    reorderableColumns
                    virtualScrollerOptions={{ itemSize: 44.5 }}
                    onColReorder={(e: any) =>
                      onColumnDragEquity(e.columns, e.dropIndex)
                    }
                    onRowReorder={(e: any) =>
                      setBackdatedFilteredEQData(e.value)
                    }
                    removableSort
                    tableStyle={{ minWidth: "50rem" }}
                    rowClassName={backDatedActiveTrade}
                  >
                    <Column
                      frozen
                      className="reorder"
                      rowReorder
                      style={{
                        width: "3rem",
                        background: "#dae6f1",
                        zIndex: "1",
                      }}
                    />
                    {orderedColEq?.map((col: any, index: any) => (
                      <Column
                        field={String(
                          getColumnDiv(
                            "field",
                            col,
                            backdatedeqVisibleColumnsState
                          )
                        )}
                        header={col.header}
                        sortable={
                          [
                            "n_open_transaction_price",
                            "s_reason",
                            "exit_price",
                            "trade_type",
                          ].includes(col.field)
                            ? false
                            : true
                        }
                        body={(e: any) => (
                          <>
                            {[
                              "P/L",
                              "P/L (₹)",
                              "1D P/L",
                              "1D Return(%)",
                              "Return(%)",
                              "Return After Cost (%)",
                              "P/L (Exclusive of Dividend)",
                            ].includes(col.header) ? (
                              <div
                                style={{
                                  border: "none",
                                  color: getFontColorAsPerValue(e[col.field]),
                                }}
                                className="hovertextdiv hoverd"
                                data-hover={
                                  e[col.field] !== undefined
                                    ? Number(e[col.field])?.toFixed(4)
                                    : ""
                                }
                              >
                                {handlevalue(
                                  e.identifier,
                                  e[col.field],
                                  "index"
                                )}{" "}
                              </div>
                            ) : (
                              <div>{e[col.field]} </div>
                            )}
                          </>
                        )}
                      ></Column>
                    ))}
                  </DataTable>
                )
                //  : adviceType === "EqN50plus" ? (
                //   <DataTable
                //     value={BackdatedFilteredEqN50Data}
                //     header={header}
                //     id="selected_row"
                //     scrollable
                //     selectionMode="single"
                //     selection={selectedTrade || BackdatedFilteredEqN50Data[0]}
                //     onSelectionChange={(e: any) => {
                //       e?.value && setSelectedTrade(e.value);
                //     }}
                //     dataKey="uuid"
                //     onRowSelect={onRowSelectBackdated}
                //     columnResizeMode="expand"
                //     resizableColumns
                //     reorderableRows
                //     reorderableColumns
                //     onColReorder={(e: any) =>
                //       onColumnDragEquity(e.columns, e.dropIndex)
                //     }
                //     onRowReorder={(e: any) =>
                //       setBackdatedFilteredEqN50Data(e.value)
                //     }
                //     removableSort
                //     tableStyle={{ minWidth: "50rem" }}
                //     rowClassName={backDatedActiveTrade}
                //   >
                //     <Column
                //       frozen
                //       className="reorder"
                //       rowReorder
                //       style={{
                //         width: "3rem",
                //         background: "#dae6f1",
                //         zIndex: "1",
                //       }}
                //     />

                //     {orderedColEq?.map((col: any, index: any) => (
                //       <Column
                //         field={String(
                //           getColumnDiv(
                //             "field",
                //             col,
                //             backdatedeqVisibleColumnsState
                //           )
                //         )}
                //         header={col.header}
                //         sortable={
                //           [
                //             "n_open_transaction_price",
                //             "s_reason",
                //             "exit_price",
                //             "trade_type",
                //           ].includes(col.field)
                //             ? false
                //             : true
                //         }
                //         body={(e: any) => (
                //           <>
                //             {[
                //               "P/L",
                //               "P/L (₹)",
                //               "1D P/L",
                //               "1D Return(%)",
                //               "Return(%)",
                //               "Return After Cost (%)",
                //             ].includes(col.header) ? (
                //               <div
                //                 style={{
                //                   border: "none",
                //                   color: getFontColorAsPerValue(e[col.field]),
                //                 }}
                //                 className="hovertextdiv hoverd"
                //                 data-hover={
                //                   e[col.field] !== undefined
                //                     ? Number(e[col.field])?.toFixed(4)
                //                     : ""
                //                 }
                //               >
                //                 {handlevalue(
                //                   e.identifier,
                //                   e[col.field],
                //                   "index"
                //                 )}{" "}
                //               </div>
                //             ) : (
                //               <div>{e[col.field]} </div>
                //             )}
                //           </>
                //         )}
                //       ></Column>
                //     ))}
                //   </DataTable>
                // ) 
                : (
                  ""
                )}
              </div>
            </div>
            <div className="params_div">
              <div className="params_content">
                <div className="params_heading">
                  <span className="detals_heading">Details</span>
                  <div className="m2m_graph">
                    {m2mArrayLoading ? (
                      <ThreeDots
                        visible
                        height="60"
                        width="60"
                        color="#8eabc5"
                        radius="9"
                        ariaLabel="three-dots-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                      />
                    ) : (
                      <M2mGraphChart
                        key={selectedTrade?.unique_id}
                        uniqueId={" "}
                        m2marray={m2mGraphArray}
                        page={"Back"}
                      />
                    )}
                  </div>
                </div>
                <div className="under_params_heading">
                  {backdatedDesc_ts?.length > 0 ? (
                    <>
                      <Parameters
                        desc_ts={backdatedDesc_ts}
                        stockStrength={stockStrength}
                        theme={theme}
                      />
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {!loading &&
                adviceType === "EQ" &&
                Object.keys(tradeReason).length > 0 && (
                  <PDFDownloadLink
                    document={<ProductNote tradeReason={tradeReason} />}
                    fileName={`${tradeReason["s_symbol"]}_${tradeReason["dt_date"]}.pdf`}
                  >
                    <div className="pdfDownloadStyle">
                      Product note
                      <HiOutlineDownload size={20} />
                    </div>
                  </PDFDownloadLink>
                )}
            </div>
          </div>
        )}
      </div>
      {/* <div
        id="stock_chart"
        className={`Nifty_charts_main_div ${
          !viewSTOCKCharts ? "" : "Nifty_charts_main_div_close"
        }`}
        onClick={() => {
          setViewSTOCKCharts(true);
        }}
      > */}
        {/* {!viewSTOCKCharts ? (
          <>
            <span className="viewChartsSvgImg">
              <IoBarChartSharp />
            </span>
            <span className="view_charts ">View Stock Chart</span>
          </>
        ) : (
          " "
        )} */}
      {/* </div> */}
      {/* {viewSTOCKCharts && (
        <StockChart
          selectedDate={selectedDate}
          setViewSTOCKCharts={setViewSTOCKCharts}
          adviceType={adviceType}
        />
      )} */}

      <div
        className={`Nifty_charts_main_div ${
          !viewNIFTYCharts ? "" : "Nifty_charts_main_div_close"
        }`}
        onClick={() => {
          setViewNIFTYCharts(true);
        }}
      >
        {!viewNIFTYCharts ? (
          <>
            <span className="viewChartsSvgImg">
              <IoBarChartSharp />
            </span>
            <span className="view_charts">
              View Live Sentiment (NIFTY 50 Spot)
            </span>
          </>
        ) : (
          " "
        )}
      </div>
      {viewNIFTYCharts && (
        <ChartComponent
          selectedDate={selectedDate}
          setViewNIFTYCharts={setViewNIFTYCharts}
        />
      )}

      <div
        style={{
          marginTop: "1rem",
          width: "1%",
          height: "1rem",
          border: "1px solid transparent",
        }}
      ></div>
      {/* modalshow < 3 && releaseNoteShow */}
      <Modal
        show={false}
        className="feedSense_modal"
        onHide={handleClose}
        style={{ userSelect: "none" }}
        size="lg"
        presentationStyle="fullScreen"
      >
        <Modal.Header className="feedSense_modal_header" closeButton>
          <Modal.Title style={{ width: "100%", fontWeight: "bolder" }}>
            <img
              style={{ width: "16%" }}
              src="/icon/vista_logo.png"
              alt="feedsense"
            />
            <span style={{ fontSize: "1.5rem", fontWeight: "100" }}>
              FeedSense - {APP_VERSION} Release Note
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="feedSense_modal_header">
          <div
            style={{
              width: "96%%",
              height: "100%",
              fontFamily: "Nunito",
              padding: "0 15px 15px 15px",
            }}
          >
            <div className="privacy-policy-headers">
              {" "}
              <FontAwesomeIcon
                className="font-awesome-header-icon"
                icon={faArrowAltCircleRight}
              />{" "}
              Release Date {releaseDetails?.release_date}
            </div>
            <div className="privacy-policy-headers">
              {" "}
              <FontAwesomeIcon
                className="font-awesome-header-icon"
                icon={faArrowAltCircleRight}
              />{" "}
              Added
            </div>
            <div style={{ padding: "15px" }}>
              {releaseDetails?.Added?.map((item: any) => {
                return (
                  <div style={{ textAlign: "left" }}>
                    {" "}
                    <FontAwesomeIcon
                      className="font-awesome-icon"
                      icon={faCircle}
                    />{" "}
                    {item?.s_details}
                  </div>
                );
              })}
            </div>
            <div className="privacy-policy-headers">
              {" "}
              <FontAwesomeIcon
                className="font-awesome-header-icon"
                icon={faArrowAltCircleRight}
              />{" "}
              Improvements
            </div>
            <div style={{ padding: "15px" }}>
              {releaseDetails?.improvements?.map((item: any) => {
                return (
                  <div style={{ textAlign: "left" }}>
                    {" "}
                    <FontAwesomeIcon
                      className="font-awesome-icon"
                      icon={faCircle}
                    />{" "}
                    {item?.s_details}
                  </div>
                );
              })}
            </div>
            <div className="agree-terms">
              <input
                type="checkbox"
                id="agreeChk"
                className="agree"
                checked={releaseNoteChkBox}
                onChange={(e) => handleReleaseCheck(e)}
              />
              <span style={{ fontWeight: "bold" }}>
                {" "}
                I read and agree to Feedsense AI terms of use.
              </span>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}




/* JSON for column reordering by default

{"equity":[{"field":"s_symbol","header":"Symbol"},{"field":"s_code","header":"Code"},{"field":"dt_date","header":"Open Date"},{"field":"dt_close_date","header":"Close Date"},{"field":"dt_entry_time","header":"Open Time"},{"field":"dt_exit_time","header":"Close Time"},{"field":"s_trade_type","header":"Trade Type"},{"field":"n_transaction","header":"Transaction"},{"field":"n_exit_price","header":"LTP"},{"field":"s_status","header":"Status"},{"field":"n_return","header":"Return(%)"},{"field":"n_return_after_cost","header":"Return After Cost (%)"},{"field":"n_pl","header":"P/L"},{"field":"n_pl_rs","header":"P/L (₹)"},{"field":"pl_with_dividend","header":"P/L (Exclusive of Dividend)"},{"field":"oneDayPl","header":"1D P/L"},{"field":"oneDay_return_per","header":"1D Return(%)"}],"opt":[{"field":"s_symbol","header":"Symbol"},{"field":"s_code","header":"Code"},{"field":"dt_date","header":"Open Date"},{"field":"dt_entry_time","header":"Open Time"},{"field":"dt_exit_time","header":"Close Time"},{"field":"s_trade_type","header":"Trade Type"},{"field":"n_transaction","header":"Transaction"},{"field":"n_exit_price","header":"LTP"},{"field":"s_status","header":"Status"},{"field":"n_return","header":"Return(%)"},{"field":"n_return_after_cost","header":"Return After Cost (%)"},{"field":"n_pl","header":"P/L"},{"field":"n_pl_rs","header":"P/L (₹)"}],"poly":[{"field":"s_symbol","header":"Symbol"},{"field":"s_code","header":"Code"},{"field":"dt_date","header":"Open Date"},{"field":"dt_close_date","header":"Close Date"},{"field":"dt_entry_time","header":"Open Time"},{"field":"dt_exit_time","header":"Close Time"},{"field":"s_trade_type","header":"Trade Type"},{"field":"n_transaction","header":"Transaction"},{"field":"n_exit_price","header":"LTP"},{"field":"s_status","header":"Status"},{"field":"n_return","header":"Return(%)"},{"field":"n_return_after_cost","header":"Return After Cost (%)"},{"field":"n_pl","header":"P/L"},{"field":"n_pl_rs","header":"P/L (₹)"},{"field":"oneDayPl","header":"1D P/L"},{"field":"oneDay_return_per","header":"1D Return(%)"}]}

*/

